/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      if (jQuery(form).hasClass('product-type-byob') == false) {
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.changeItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeChangeItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemChanged(line_item, form);
      }
      if (jQuery(form).hasClass('product-type-byob') == false) {
        $body.trigger('afterChangeItem.ajaxCart', [line_item, form]);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback,doneFreeGiftProduct,isBYOB) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart,doneFreeGiftProduct,isBYOB);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      //$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

Handlebars.registerHelper('if_eq', function(a, b, opts) {
  if (a == b) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, loadCartWithOutGetCart, loadWithOutCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $formContainerRemove, $addToCart, $removeToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $emptySelector, $triggerSelector, isBYOB;

  // Private functions
  var updateCountPrice, formOverride, formOverrideRemove, itemAddedCallback, itemRemovedCallback, itemErrorCallback, cartUpdateCallback, cartWithOutUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, sizeCartDrawerFooter, submitAjaxCart;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      formSelectorRemove : 'form[action^="/cart/change"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      triggerSelector    : null,
      emptySelector      : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $formContainerRemove     = $(settings.formSelectorRemove);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $removeToCart      = $formContainerRemove.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $emptySelector     = $(settings.emptySelector);
    $triggerSelector   = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
      formOverrideRemove();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    
    $( window ).resize(function() {
      sizeCartDrawerFooter();
      setTimeout(function() {
        sizeCartDrawerFooter();
      }, 1000)
    });
    $( window ).scroll(function() {
      sizeCartDrawerFooter();
      setTimeout(function() {
        sizeCartDrawerFooter();
      }, 1000)
    });
  };

  loadCart = function (doneFreeGiftProduct) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback, doneFreeGiftProduct);
  };

  loadCartWithOutGetCart = function (cart,doneFreeGiftProduct) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    $body.addClass('drawer--is-loading');
    cartUpdateCallback(cart,doneFreeGiftProduct);
    //ShopifyAPI.getCart(cartUpdateCallback, doneFreeGiftProduct);
  };

  loadWithOutCart = function () {
    ShopifyAPI.getCart(cartWithOutUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      var productPouches = 0,
          totalPouches = 0;
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      var productSubscription = false;
      $.each(cart.items, function(index, cartItem) {
        productSubscription = false;
        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
          });
        }
        if (Object.keys(productsSubscritionJson).length > 0) {
          if(productSubscription == true) {
            //console.log(price);
            for (var x in productsSubscritionJson) {
              //console.log(productsSubscritionJson[x]);
              if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                  productPouches = productsSubscritionJson[x]['pouches'];
                  break;
                }
              }
            }
          } else {
            if (productsSubscritionJson[cartItem.product_id] != undefined) {
              productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
            }
          }
        }
        totalPouches += productPouches*cartItem.quantity;
      });
      //$cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $cartCountSelector.html(totalPouches).removeClass('hidden-count');

      //if (cart.item_count === 0) {
      if (totalPouches === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.off('submit').on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');
      document.querySelector('body').classList.add("site--is-loading");

      // Remove any previous quantity errors
      $('.qty-error').remove();

      isBYOB = false;
      let productTitle = $(evt.target).closest('.product-top').find('.product__title').text();
      if ($(evt.target).hasClass('product-type-byob') == true) {
        //console.log('formContainer','product-type-byob');
        isBYOB = true;
        swal.close();
        //console.log('js-product-add-text',$(evt.target).find('.js-product-add-text').text());
        if (typeof mixpanel.track === 'function') {
          if ($(evt.target).find('.js-product-add-text').text() == 'Add Another') {
            mixpanel.track("BYOP Add Another", {"name": productTitle});
          } else {
            mixpanel.track("BYOP Add to Pack", {"name": productTitle});
          }
        }
      } else {
        if (typeof mixpanel.track === 'function') {
          mixpanel.track("Premade Pack Add to Cart", {"name": productTitle});
        }
      }

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  formOverrideRemove = function () {
    $formContainerRemove.off('submit').on('submit', function(evt) {
      evt.preventDefault();//console.log(evt.target.querySelector('[name="id"]').value,$(evt.target).find('[name="id"]').val());

      // Add class to be styled if desired
      $removeToCart.removeClass('is-removed').addClass('is-removing');
      document.querySelector('body').classList.add("site--is-loading");

      // Remove any previous quantity errors
      $('.qty-error').remove();

      isBYOB = false;
      if ($(evt.target).hasClass('product-type-byob') == true) {
        //console.log('formContainerRemove','product-type-byob');
        isBYOB = true;
      	let productTitle = $(evt.target).closest('.product-top').find('.product__title').text();
        if (typeof mixpanel.track === 'function') {
          mixpanel.track("BYOP Remove", {"name": productTitle});
        }
      }

      ShopifyAPI.changeItemFromForm(evt.target, itemRemovedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    /*
    if (typeof toast.create == 'function') {
      //console.log('product',product);
      toast.create({
        title: 'New item added!',
        text: product.product_title,
        qty: product.quantity,
        image: product.image.replace('.jpg','_400x400.jpg').replace('.png','_400x400.png'),
      });
    }
    */
    window.liQ = window.liQ || [];
    if (typeof window.liQ.push != 'undefined') {
      window.liQ.push({
          "event": "addToCart",
          "email": theme.ajaxCartSettings.userEmail,
          "items": [
              {
                  "id": product.variant_id.toString(),
                  "price": product.price.toString(),
                  "quantity": "1",
                  "currency": theme.ajaxCartSettings.currency
              }
          ]
      });
    }

    if (isBYOB == true) {
      ShopifyAPI.getCart(cartUpdateCallback,false,isBYOB);
    }
    $body.trigger('afterChangeItem.ajaxCart');
  };

  itemRemovedCallback = function (product) {
    $addToCart.removeClass('is-removing').addClass('is-removed');

    if (isBYOB == true) {
      ShopifyAPI.getCart(cartUpdateCallback,false,isBYOB);
    }
    $body.trigger('afterChangeItem.ajaxCart');
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart, doneFreeGiftProduct, isBYOB) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(isBYOB === undefined) {
      isBYOB = false;
    }
    let doneRulesDiscount = false;
    if (typeof Shopify.checkCartDiscountRules == 'function') {
      cart = Shopify.checkCartDiscountRules(cart);
    }

      if (isBYOB == true) {
        if(typeof dRRulesDiscount == 'function') {
          var cartSubscription = false;
          if (cart['attributes']['BYOK'] == null || cart['attributes']['BYOK'] == 'No') {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: 'attributes[BYOK]=Yes',
              async: false,
              dataType: 'json',
              success: function (newCart) {
                //console.log('cartUpdateCallback-updateBYOP',newCart);
                cart = newCart;
              }
            });
          }
          if (cart['attributes']['Product Type'] == 'Subscription') {
            var cartSubscription = true;
          }
          var productPouches = 0;
          var total_price = 0;
          var totalPouches = 0;
          $.each(cart.items, function(index, cartItem) {
            var price = cartItem.price * cartItem.quantity;
            var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
            if (Object.keys(productsSubscritionJson).length > 0) {
              //console.log(price);
              if(cartSubscription == true) {
                for (let x in productsSubscritionJson) {
                  //console.log(productsSubscritionJson[x]);
                  if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                    //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                    if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                      productPouches = productsSubscritionJson[x]['pouches'];
                      price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                      break;
                    }
                  }
                }
                //console.log(price);
              } else {
                if (productsSubscritionJson[cartItem.product_id] != undefined) {
                  productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
                }
              }
            }
            total_price += price;
            totalPouches += productPouches*cartItem.quantity;
          });
          dRRulesDiscount(totalPouches,cartSubscription);
          doneRulesDiscount = true;
        }
        // Update quantity and price
        updateCountPrice(cart);
    
        if(typeof Shopify.gamification != 'undefined' && typeof Shopify.gamification.dRUpdateBYOB == 'function') {
          //console.log('cartUpdateCallback','cart',cart)
          cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
        }
      }

      if (isBYOB == false || typeof dRRulesDiscount != 'function') {
        if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct != true) {
          var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
          //console.log('cartUpdateCallback-result',result);
          if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
            ShopifyAPI.getCart(cartUpdateCallback);
            return false;
          } else {
            cart = result.cart;
            doneFreeGiftProduct = true;
          }
        }
      }

    if (isBYOB == false) {
      // Update quantity and price
      updateCountPrice(cart);
      buildCart(cart,doneFreeGiftProduct,doneRulesDiscount);
    }
  };
  
  cartWithOutUpdateCallback = function (cart) {
    let doneFreeGiftProduct = false;
    let doneRulesDiscount = false;
    if(typeof dRRulesDiscount == 'function') {
      var cartSubscription = false;
      if (cart['attributes']['BYOK'] == null || cart['attributes']['BYOK'] == 'No') {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: 'attributes[BYOK]=Yes',
          async: false,
          dataType: 'json',
          success: function (newCart) {
            //console.log('cartUpdateCallback-updateBYOP',newCart);
            cart = newCart;
          }
        });
      }
      if (cart['attributes']['Product Type'] == 'Subscription') {
        var cartSubscription = true;
      }
      var productPouches = 0;
      var total_price = 0;
      var totalPouches = 0;
      $.each(cart.items, function(index, cartItem) {
        var price = cartItem.price * cartItem.quantity;
        var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
        if (Object.keys(productsSubscritionJson).length > 0) {
          //console.log(price);
          if(cartSubscription == true) {
            for (let x in productsSubscritionJson) {
              //console.log(productsSubscritionJson[x]);
              if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                  productPouches = productsSubscritionJson[x]['pouches'];
                  price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                  break;
                }
              }
            }
            //console.log(price);
          } else {
            if (productsSubscritionJson[cartItem.product_id] != undefined) {
              productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
            }
          }
        }
        total_price += price;
        totalPouches += productPouches*cartItem.quantity;
      });
      dRRulesDiscount(totalPouches,cartSubscription);
      doneRulesDiscount = true;
    }
    // Update quantity and price
    updateCountPrice(cart);

    if(typeof Shopify.gamification != 'undefined' && typeof Shopify.gamification.dRUpdateBYOB == 'function') {
      console.log('cartUpdateCallback','cart',cart)
      cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
    }

    if (typeof dRRulesDiscount != 'function') {
      if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct != true) {
        var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        //console.log('cartUpdateCallback-result',result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      }
    }
  };

  buildCart = function (cart,doneFreeGiftProduct,doneRulesDiscount) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(doneRulesDiscount === undefined) {
      doneRulesDiscount = false;
    }
    let buildYourKit = null;
    if ($cartContainer.find('.build-your-kit.wrapper').length) {
      buildYourKit = $cartContainer.find('.build-your-kit.wrapper').clone();
    }
    // Start with a fresh cart div
    $cartContainer.empty();

    //Update for Gamification AB - Correct Discount
    let changeABGamification = false;

    // Show empty cart
    if (cart.item_count === 0) {
      $(settings.emptySelector).show().addClass('subscription');
      $(settings.triggerSelector).removeClass('js-cart-full');
      //let newData = "attributes[Product Type]=One Time";
      //console.log('mixpanel.get_distinct_id()',typeof mixpanel.get_distinct_id !== 'function');
      let newData = "attributes[Product Type]=Subscription&attributes[BYOK]=Yes";
      if (typeof mixpanel.get_distinct_id === 'function') {
        newData = newData + "&attributes[mixpanel_id]=" + mixpanel.get_distinct_id();
      }

      //if (cart['attributes']['Product Type'] != 'One Time') {
      if (cart['attributes']['Product Type'] != 'Subscription' || cart['attributes']['BYOK'] != 'Yes') {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: newData,
          async: false,
          dataType: "json",
          success: function(t) {
            console.log('buildCart',t);
            cart = t;
          }
        });
      }
      cartCallback(cart);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.triggerSelector).addClass('js-cart-full');
      
      if(cart['attributes'] == undefined || cart['attributes']['BYOK'] != 'Yes' || cart['attributes']['mixpanel_id'] == undefined) {
        let newData = "attributes[BYOK]=Yes";
        if (typeof mixpanel.get_distinct_id === 'function') {
          newData = newData + "&attributes[mixpanel_id]=" + mixpanel.get_distinct_id();
        }
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: newData,
          async: false,
          dataType: "json",
          success: function(t) {
            console.log('buildCart',t);
            cart = t;
          }
        });
      }
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    var cartBYOK = false,
        cartBYOKDiscount = false,
        cartBYOKLinesDiscount = 0,
        cartBYOKLinesWithOutDiscount = 0,
        foundAllSubscription = true,
        cartLinesDiscount15 = 0,
        cartSubscription = false;
    
    if (cart.attributes != undefined) {
      if (cart.attributes["BYOK"] != undefined) {
        if (cart.attributes["BYOK"] == 'Yes') {
          cartBYOK = true;
        }
      }
      if ( cart.attributes["Discount code"] && cart.attributes["Discount code"] != 'False' ) {
        cartBYOKDiscount = cart.attributes["Discount code"];
      }
    }

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {


      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_240x240_crop_center$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      var productBYOK = false,
          productFreeGift = false,
          productBYOKorFreeGift = false,
          productSubscription = false;
      
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
          if (key === 'Product from' && value === 'BYOK page') {
            productBYOK = true;
          }
          if (key === 'Free' && value === 'Gift') {
            productFreeGift = true;
          }
          if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
            productSubscription = true;
            cartSubscription = true;
          }
        });
      }
      if ((productSubscription == false) && (productFreeGift == false)) {
        foundAllSubscription = false;
      }
      //productBYOK = $('body').hasClass('template-gamification-b') == false ? productBYOK : false;
      productBYOK = false;
      productBYOKorFreeGift = productBYOK || productFreeGift;
            
      var product_title = cartItem.product_title;
      var final_line_price = cartItem.final_line_price;
      var price = 0;
      var url = cartItem.url;
      var handle = cartItem.handle;
      if ( productSubscription == true ) {
        var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
        if (Object.keys(productsSubscritionJson).length > 0) {
          var result = ``;
          for (var productSubscritionJson in productsSubscritionJson) {
            // obj.hasOwnProperty() is used to filter out properties from the object's prototype chain
            if (productsSubscritionJson.hasOwnProperty(productSubscritionJson)) {
              if (productsSubscritionJson[productSubscritionJson]['subscriptionProductId'] == cartItem.variant_id) {
                url = productsSubscritionJson[productSubscritionJson]['url'];
                handle = productsSubscritionJson[productSubscritionJson]['handle'];
                price = productsSubscritionJson[productSubscritionJson]['price'] * cartItem.quantity;
              }
            }
          }
        }
      }
      if (cartItem.product_type == "Single") {
        url = "/collections/build-your-own-pack?product-sku=" + handle;
      }
      if (price != 0) {
        cartBYOKLinesWithOutDiscount = cartBYOKLinesWithOutDiscount + price;
      } else {
        cartBYOKLinesWithOutDiscount = cartBYOKLinesWithOutDiscount + final_line_price;
      }
      product_title = 0 < product_title.indexOf("-") ? product_title.split("-")[0] : product_title;

        if (cartBYOK == true && cartBYOKDiscount != false && productSubscription == true) {
          //if (cartItem.product_title.indexOf('Off Auto renew') > -1) {
          if (cartItem.product_title.indexOf('Auto renew') > -1 && cartItem.product_title.indexOf('Shark Tank') < 0) {
            let discountReplace = '15';
            if (cartBYOKDiscount.indexOf('2077J038XQDE') > -1) { // Cupon for discount 20%
              discountReplace = '20';
              final_line_price = final_line_price - (final_line_price * 5.84 / 100);
            }
            if (cartItem.product_title.indexOf('Auto renew') > -1 && product_title.indexOf('Auto renew') == -1) {
              product_title = product_title + ' Auto renew';
            }
          } else {
            product_title = product_title + ' Auto renew';
          }
        } else if ( product_title.indexOf("Auto renew") == -1 && cartItem.product_title.indexOf("Auto renew") > -1 ) {
          //product_title = product_title + ' 15.00% Off Auto renew';
          product_title = product_title + ' Auto renew';
        } else if (cartBYOK == true && cartBYOKDiscount != false) {
          if (cartBYOKDiscount.indexOf('5PMAD5PDJTH3') > -1) { // Cupon for discount 5%
            final_line_price = final_line_price - (final_line_price * 5 / 100);
          }
          if (cartBYOKDiscount.indexOf('10XTH7YZNWPX') > -1) { // Cupon for discount 10%
            final_line_price = final_line_price - (final_line_price * 10 / 100);
          }
        }

      cartBYOKLinesDiscount = cartBYOKLinesDiscount + final_line_price;
      
      if ( productSubscription == true ) {
        cartLinesDiscount15 = cartLinesDiscount15 + final_line_price;
      } else {
        cartLinesDiscount15 = cartLinesDiscount15 + cartItem.final_line_price - (cartItem.final_line_price * 0.15);
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: url,
        img: prodImg,
        //name: product_title,
        name: 0 < product_title.indexOf("-") ? product_title.split("-")[0] : product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(final_line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),

        lineDiscount: cartItem.line_level_discount_allocations.length,
        lineDiscounts: cartItem.line_level_discount_allocations.map((obj) => Object.keys(obj).reduce((acc, key) => {
                      if (key === "amount") {
                        acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
                      } else {
                        acc[key] = obj[key];
                      }
                      return acc;
                    }, {})),
        lineDiscountedPrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),

        discounts: cartItem.discounts,
        discountPrice: Shopify.formatMoney(cartItem.original_price - cartItem.discounted_price, settings.moneyFormat),
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        discountedPrice: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat),
        
        productBYOK: productBYOK,
        productFreeGift: productFreeGift,
        productBYOKorFreeGift: productBYOKorFreeGift,
        productSubscription: productSubscription
      };

      items.push(item);
    });

    var productSuggestion = {};
    var productSuggestionFound = false;
    if (typeof searchSuggestion === "function") {
      productSuggestion = searchSuggestion(cart);
      if(Object.keys(productSuggestion).length > 0) {
        productSuggestionFound = true;
      }
      //console.log('productSuggestion',productSuggestion);
    }
    //console.log('cartBYOK',cartBYOK,'cartBYOKDiscount',cartBYOKDiscount,'cartBYOKLinesDiscount',cartBYOKLinesDiscount);
    if (cartBYOK == true && cartBYOKDiscount != false && cartBYOKDiscount.indexOf('5RCYD5VT0S57') > -1) { // Cupon for discount $5
      cartBYOKLinesDiscount = cartBYOKLinesDiscount - 500;
    }
    //console.log('cartBYOKLinesDiscount',cartBYOKLinesDiscount);
  
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      //totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cartBYOKLinesDiscount, settings.moneyFormat),

      cartDiscount: cart.cart_level_discount_applications.length,
      cartDiscounts: cart.cart_level_discount_applications.map((obj) => Object.keys(obj).reduce((acc, key) => {
                      if (key === "total_allocated_amount") {
                        acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
                      } else {
                        acc[key] = obj[key];
                      }
                      return acc;
                    }, {})),

      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      
      cartBYOK: cartBYOK,
      cartBYOKDiscount: cartBYOKDiscount,
      foundAllSubscription: foundAllSubscription,
      cartSubscription: cartSubscription,
      isFreeShipping: cart.total_price >= theme.ajaxCartSettings.subscribeFree ? true : false,
      subscribeText: cart.total_price >= theme.ajaxCartSettings.subscribeFree ? theme.ajaxCartSettings.subscribeTextFree : theme.ajaxCartSettings.subscribeText,
      productSuggestion: productSuggestion,
      productSuggestionFound: productSuggestionFound,
      isCartBYOKLinesWithOutDiscount: cartBYOKLinesWithOutDiscount == cartBYOKLinesDiscount ? false : true,
      cartBYOKLinesWithOutDiscount: Shopify.formatMoney(cartBYOKLinesWithOutDiscount, settings.moneyFormat)
    }
                               
    $cartContainer.append(template(data));

    if ($cartContainer.find('.build-your-kit.wrapper').length && buildYourKit != null) {
      buildYourKit = $cartContainer.find('.build-your-kit.wrapper').replaceWith(buildYourKit);
    }
    
    if (cartLinesDiscount15 >= theme.ajaxCartSettings.subscribeFree) {
      $('.ajaxcart__subs .ajaxcart__form-subs-text').html(theme.ajaxCartSettings.subscribeTextFree);
    } else {
      $('.ajaxcart__subs .ajaxcart__form-subs-text').html(theme.ajaxCartSettings.subscribeText);
    }
    if($('body').hasClass('template-gamification-b') == true) {
      if (cartBYOKDiscount != false) {
        if ((cartBYOKDiscount.indexOf('2077J038XQDE') > -1) || (cartBYOKDiscount.indexOf('10XTH7YZNWPX') > -1)) {
          $('.ajaxcart__subs .ajaxcart__form-subs-text').html($('.ajaxcart__subs .ajaxcart__form-subs-text').html().replace('15%', '20%'));
        }
      }
    }
    
    if (cart.total_price >= theme.ajaxCartSettings.subscribeFree) {
      $('.ajaxcart__button .ajaxcart__button-bottom').html(theme.ajaxCartSettings.dayGuaranteeTextFree);
    } else {
      $('.ajaxcart__button .ajaxcart__button-bottom').html(theme.ajaxCartSettings.dayGuaranteeText);
    }
    
    if (typeof searchSuggestion === "function") {
      $('.productSuggestion-title').text(theme.productSuggestionStrings.header);
      $('.ajaxcart__addSuggestion').text(theme.productSuggestionStrings.buttonLabel);
    }

    submitAjaxCart(cartSubscription);
    
    cartCallback(cart, doneFreeGiftProduct, doneRulesDiscount);
  };

  cartCallback = function(cart, doneFreeGiftProduct, doneRulesDiscount) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(doneRulesDiscount === undefined) {
      doneRulesDiscount = false;
    }
    //if($('body').hasClass('template-gamification-b') == true) {
      if(typeof Shopify.gamification != 'undefined' && typeof Shopify.gamification.dRUpdateBYOB == 'function') {
        cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
      }
    //}

    if (typeof searchSuggestion === "function") {
      //console.log('ajaxcart__product',$('.ajaxcart__product-suggestion-empty .product .product__media .o-ratio__content'));
      if ($('.ajaxcart__product-suggestion-empty .product .product__media .o-ratio__content').length > 0) {
        if ($('.ajaxcart__product-suggestion-empty .product .product__media .o-ratio__content.slick-initialized').length == 0) {
          $('.ajaxcart__product-suggestion-empty .product .product__media .o-ratio__content').slick({
            infinite: false,
            dots: true,
            prevArrow: `<button class="slide-arrow prev-arrow">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle r="19.5" transform="matrix(-1 0 0 1 20 20)" fill="white" stroke="white"/>
                  <path d="M20.3627 19.0861C21.116 17.7207 22.0198 16.4753 22.6224 15.3349C22.8107 14.9898 23.0517 14.5847 22.7429 14.2246C22.4341 13.8645 21.7035 14.007 21.3193 14.1721C20.6028 14.5182 19.9063 14.9039 19.2329 15.3274C16.4618 17.0175 13.3686 18.116 10.1491 18.5535C9.72728 18.5985 9.1925 18.5159 9.03432 19.0936C8.87614 19.6713 9.29795 19.8889 9.62183 20.204C12.0698 22.5522 15.1354 23.7451 18.2537 24.8479C19.2405 25.2005 20.2648 25.4631 21.2666 25.7407C21.7713 25.8757 22.3889 26.2884 22.7731 25.6657C23.1572 25.043 22.4793 24.8104 22.1479 24.4578L19.4815 21.6369C19.7526 21.3368 20.6038 21.5019 21.0632 21.4569C22.8309 21.4027 24.5992 21.5436 26.3358 21.877C27.6012 22.0645 32 22.9648 32 20.2865C32 18.2234 29.8834 17.218 26.2303 18.5159C24.3774 19.1386 22.1177 19.0111 20.3627 19.0861Z" fill="#84C2DF"/>
                </svg>
              </button>`,
            nextArrow: `<button class="slide-arrow next-arrow">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="19.5" fill="white" stroke="white"/>
                  <path d="M19.6373 19.0861C18.884 17.7207 17.9802 16.4753 17.3776 15.3349C17.1893 14.9898 16.9483 14.5847 17.2571 14.2246C17.5659 13.8645 18.2965 14.007 18.6807 14.1721C19.3972 14.5182 20.0937 14.9039 20.7671 15.3274C23.5382 17.0175 26.6314 18.116 29.8509 18.5535C30.2727 18.5985 30.8075 18.5159 30.9657 19.0936C31.1239 19.6713 30.7021 19.8889 30.3782 20.204C27.9302 22.5522 24.8646 23.7451 21.7463 24.8479C20.7595 25.2005 19.7352 25.4631 18.7334 25.7407C18.2287 25.8757 17.6111 26.2884 17.2269 25.6657C16.8428 25.043 17.5207 24.8104 17.8521 24.4578L20.5185 21.6369C20.2474 21.3368 19.3962 21.5019 18.9368 21.4569C17.1691 21.4027 15.4008 21.5436 13.6642 21.877C12.3988 22.0645 8 22.9648 8 20.2865C8 18.2234 10.1166 17.218 13.7697 18.5159C15.6226 19.1386 17.8823 19.0111 19.6373 19.0861Z" fill="#84C2DF"/>
                </svg>
              </button>`
          });
        } else {
          $('.ajaxcart__product-suggestion-empty .product .product__media .o-ratio__content').slick('refresh');
        }
      }
    }

    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
    sizeCartDrawerFooter();
  };
  
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
    
  submitAjaxCart = function(cartSubscription) {
    function goToCheckout(cartSubscription,cart) {
      let location_url = '';
      //console.log(cartSubscription);
      /*-- Mixpanel Code --*/
      if (typeof mixpanel.init === 'function') {
        mixpanel.init("1a682e212c332eea79a569a7d459c386");
        if (typeof mixpanel.get_distinct_id === 'function') {
          document.getElementById("mixpanel_id").value = mixpanel.get_distinct_id();
        }
        if (typeof mixpanel.track === 'function') {
          mixpanel.track("Initiate Check out");
        }
      }
      /*-- End of Mixpanel Code --*/
      if (cartSubscription) {
        var l = "",
            s = "&cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2],
            u = "myshopify_domain=".concat(Shopify.shop);
        //window.SLIDECART_CUSTOMER_ID && window.SLIDECART_CUSTOMER_EMAIL && (l = "&customer_id=".concat(window.SLIDECART_CUSTOMER_ID, "&customer_email=").concat(window.SLIDECART_CUSTOMER_EMAIL));
        try {
          var c = "&" + ga.getAll()[0].get("linkerParam");
        } catch (e) {
          c = ""
        }
        var codeCookieValue = getCookie('discount_code');
        var rechargeCookieValue = getCookie('ec-recharge-discount');
        if(codeCookieValue && !rechargeCookieValue){
          l = l.concat("&discount=" + codeCookieValue);
        } else {
          l = l.concat("&discount=" + rechargeCookieValue);
        }
        location_url = "https://checkout.rechargeapps.com/r/checkout?" + u + s + c + l;
        console.log('go to rechage checkout');
        //window.location = f;
        //return false;
      } else {
        console.log('go to shopify checkout');
        //window.location = "/checkout";
        location_url = '/checkout';
        let discount = '';
        if(cart['attributes'] != undefined) {
          //console.log(1,cart['attributes']['Discount code']);
          if(cart['attributes']['Discount code'] != undefined) {
            //console.log(2,cart['attributes']['Discount code']);
            discount = cart['attributes']['Discount code'];
          }
        }
        if (discount != '') {
          location_url = "/discount/" + discount + "?redirect=/checkout";
        }
        //console.log(5,location_url);
        //console.log(6,cart['attributes']);
        //window.location = location_url;
        //return false;
      }
      //close all popups
      $.magnificPopup.close();
      //add class for unloading
      $("body").addClass("js-theme-unloading");
      //redirect
      window.setTimeout(function() {
        location.href = location_url;
      }, 50);
    }
    $('.cart.ajaxcart__form.ajaxcart [type="submit"]').click(function(e){
      console.log('submit');
      e.preventDefault();
      $body.addClass('drawer--is-loading');
      if (isUpdating == false) {
        var result = true;
        $.ajax({
          type: 'GET',
          url: '/cart.json',
          async: false,
          dataType: 'json',
          success: function (cart) {
            var isResult = null;
            /*if($('body').hasClass('template-gamification-a') == true) {
              if(typeof freeGiftProduct == 'function') {
                isResult = freeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
                console.log('submitAjaxCart-result',isResult);
                if (isResult.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
                  result = false;
                }
              }
            } else if($('body').hasClass('template-gamification-b') == true) {*/
              if(typeof dRFreeGiftProduct == 'function') {
                isResult = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
                if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
                  result = false;
                }
              }
            //}

            if (result == false) {
              $('.cart.ajaxcart__form.ajaxcart [type="submit"]').addClass('disabled').attr("disabled", "disabled");
              $('.cart.ajaxcart__form.ajaxcart').addClass('disabled').attr("disabled", "disabled");
              return false;
            } else {
              if (isResult.cart.item_count > 0) {
                let isAllOneTime = true,
                    isBYOB = false,
                    itemsQty = 0;
                $.each(isResult.cart.items, function(index, cartItem) {
                  if (cartItem['properties'] != null) {
                    //console.log(cartItem['properties']);
                    if (cartItem['properties']['subscription_id'] != null) {
                      isAllOneTime = false;//console.log(cartItem['properties']['subscription_id']);
                    }
                    //console.log(cartItem['properties']['Product from']);
                    if (cartItem['properties']['Product from'] != null) {
                      if (cartItem['properties']['Product from'] == "BYOK page") {
                        isBYOB = true;
                      }
                    }
                    if (cartItem['properties']['Free'] != null) {
                      if (cartItem['properties']['Free'] != "Gift") {
                        itemsQty = itemsQty + cartItem.quantity;
                      }
                    } else {
                      itemsQty = itemsQty + cartItem.quantity;
                    }
                  } else {
                    itemsQty = itemsQty + cartItem.quantity;
                  }
                });
                if (gamificationDR != undefined) {
                  if (isAllOneTime == true && (itemsQty == gamificationDR.oneTime.one.min || itemsQty == gamificationDR.oneTime.two.min)) {
                    Swal.fire({
                      html: `<p class='title'>20% OFF<small>Subscribe & Save</small></p>
                            <ul>
                              <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.87" height="14.789" viewBox="0 0 13.87 14.789">
                                  <g id="Grupo_6" data-name="Grupo 6" transform="translate(-483.304 -291.188)">
                                    <rect id="Rectángulo_4" data-name="Rectángulo 4" width="9.957" height="9.957" rx="2.883" transform="translate(483.909 295.414)" fill="#fff" stroke="#238359" stroke-miterlimit="10" stroke-width="1.211"/>
                                    <g id="BKPm3t.tif">
                                      <g id="Grupo_5" data-name="Grupo 5">
                                        <g id="Grupo_4" data-name="Grupo 4">
                                          <g id="Trazado_63" data-name="Trazado 63" fill="#238359" stroke-miterlimit="10">
                                            <path d="M 488.9154052734375 303.5174255371094 C 488.8366088867188 303.5174255371094 488.7536926269531 303.5010681152344 488.6619873046875 303.4674377441406 C 488.3871154785156 303.3664855957031 488.1849365234375 303.1774291992188 488.0395202636719 303.0239868164062 L 488.02294921875 303.00634765625 C 488.009033203125 302.9913940429688 487.9959106445312 302.9772644042969 487.9854125976562 302.9692077636719 C 487.8236999511719 302.8410034179688 487.8009033203125 302.669921875 487.7826232910156 302.5324401855469 C 487.779052734375 302.5056457519531 487.7755126953125 302.4787292480469 487.7708435058594 302.4521179199219 C 487.734619140625 302.2423706054688 487.6956176757812 302.06005859375 487.6515502929688 301.8943481445312 C 487.57373046875 301.5989990234375 487.4878234863281 301.313232421875 487.4140625 301.0726013183594 C 487.3692321777344 300.9287719726562 487.3188781738281 300.7821655273438 487.2702026367188 300.640380859375 C 487.2467651367188 300.5721130371094 487.2233276367188 300.5038452148438 487.2002868652344 300.4353332519531 C 487.1734924316406 300.3574829101562 487.1466674804688 300.2784729003906 487.1198120117188 300.1994323730469 C 487.0704650878906 300.0541076660156 487.0210876464844 299.90869140625 486.9700317382812 299.7645568847656 C 486.9194641113281 299.6211853027344 486.86767578125 299.4786071777344 486.8158569335938 299.3360290527344 C 486.7496948242188 299.1538696289062 486.6812744140625 298.9655151367188 486.6166381835938 298.7784423828125 C 486.5537414550781 298.5962219238281 486.4920959472656 298.3980712890625 486.4281921386719 298.1726379394531 C 486.3722839355469 297.9720458984375 486.5243835449219 297.6416320800781 486.7622985839844 297.5647277832031 C 486.927490234375 297.5110778808594 487.0946044921875 297.4793395996094 487.2655334472656 297.4489135742188 C 487.3456726074219 297.4346923828125 487.4264221191406 297.4305114746094 487.5118713378906 297.4260864257812 C 487.5531616210938 297.4239501953125 487.5971984863281 297.4216613769531 487.6451416015625 297.4180603027344 L 487.6612548828125 297.4168701171875 L 487.67724609375 297.4192199707031 L 487.7589721679688 297.4310913085938 C 487.8354187011719 297.4420776367188 487.92529296875 297.4550170898438 488.0151672363281 297.4695434570312 C 488.0999145507812 297.4833068847656 488.2133178710938 297.535888671875 488.2732543945312 297.7082824707031 C 488.3178100585938 297.8346557617188 488.3614807128906 297.9621887207031 488.4051513671875 298.0897521972656 C 488.4619140625 298.2555236816406 488.5205993652344 298.4269714355469 488.5807189941406 298.5937194824219 C 488.6600036621094 298.8158264160156 488.7434387207031 299.0404968261719 488.8241577148438 299.2577514648438 C 488.8724365234375 299.3877258300781 488.9207153320312 299.5177307128906 488.9684448242188 299.6480102539062 C 489.0142211914062 299.7737426757812 489.0591430664062 299.8992004394531 489.1040344238281 300.0246276855469 C 489.1294555664062 300.0956115722656 489.1548461914062 300.1665649414062 489.1803894042969 300.2375183105469 C 489.2795104980469 300.0774230957031 489.3815002441406 299.91015625 489.490478515625 299.7290649414062 C 489.5977783203125 299.5506896972656 489.7044677734375 299.3720703125 489.8110961914062 299.1935424804688 C 489.9339904785156 298.9877624511719 490.0568542480469 298.7820739746094 490.1805419921875 298.5769653320312 C 490.4192810058594 298.1801147460938 490.6357116699219 297.8235473632812 490.8421325683594 297.4869995117188 L 490.9942016601562 297.2383422851562 C 491.2665710449219 296.7928466796875 491.5481872558594 296.3322143554688 491.8309936523438 295.8825988769531 C 492.0697326660156 295.50244140625 492.3307495117188 295.09912109375 492.62890625 294.649658203125 L 492.6675109863281 294.5914916992188 C 492.9009704589844 294.2398376464844 493.142333984375 293.8761901855469 493.3955078125 293.5284729003906 C 493.7582092285156 293.0316467285156 494.200439453125 292.4548034667969 494.7310485839844 291.9424438476562 C 494.9481811523438 291.7317504882812 495.1336059570312 291.5925903320312 495.3320617675781 291.4915161132812 C 495.5383605957031 291.3863220214844 495.7532043457031 291.3329467773438 495.9705505371094 291.3329467773438 C 496.1058044433594 291.3329467773438 496.2435607910156 291.353759765625 496.3799133300781 291.3948364257812 C 496.6001586914062 291.4601440429688 496.7730102539062 291.6157836914062 496.8931274414062 291.8572998046875 C 497.0232238769531 292.1162109375 497.0596923828125 292.3700561523438 497.001220703125 292.6112365722656 C 496.9559020996094 292.8022766113281 496.8475036621094 292.9777526855469 496.6792297363281 293.1321105957031 C 496.5499267578125 293.2512512207031 496.3773193359375 293.4060668945312 496.1906433105469 293.544677734375 C 495.8704223632812 293.7848510742188 495.5794372558594 294.053466796875 495.3263854980469 294.3427124023438 C 495.07470703125 294.6318054199219 494.8191223144531 294.93994140625 494.5669250488281 295.2582397460938 C 494.3363037109375 295.5479736328125 494.1130981445312 295.8437194824219 493.9032592773438 296.1374816894531 C 493.6168823242188 296.5397338867188 493.3255004882812 296.9619140625 493.0126647949219 297.427978515625 C 492.8109741210938 297.7290954589844 492.6083068847656 298.0473022460938 492.3931274414062 298.4006042480469 C 492.1265563964844 298.8389587402344 491.8506774902344 299.3045349121094 491.5497436523438 299.8238525390625 C 491.3167724609375 300.2240905761719 491.0852966308594 300.6354064941406 490.8614501953125 301.0331726074219 L 490.8186340332031 301.1092834472656 C 490.7525939941406 301.2272338867188 490.6875305175781 301.3463745117188 490.6223754882812 301.4655456542969 C 490.5139770507812 301.6639404296875 490.40185546875 301.8691101074219 490.2854919433594 302.0682983398438 L 490.2500305175781 302.1293640136719 C 490.0357971191406 302.49853515625 489.8142395019531 302.8802795410156 489.4977416992188 303.1967468261719 C 489.3922729492188 303.3033752441406 489.2687377929688 303.395751953125 489.1410217285156 303.4634094238281 C 489.0729370117188 303.4992980957031 488.9971008300781 303.5174255371094 488.9154052734375 303.5174255371094 Z" stroke="none"/>
                                            <path d="M 488.9154052734375 303.3721008300781 C 488.9697875976562 303.3721008300781 489.0230712890625 303.3612976074219 489.072998046875 303.3349914550781 C 489.1900024414062 303.2730102539062 489.3009948730469 303.1889953613281 489.3949890136719 303.093994140625 C 489.7149963378906 302.7739868164062 489.9349975585938 302.3819885253906 490.1600036621094 301.9949951171875 C 490.343994140625 301.6799926757812 490.5140075683594 301.3559875488281 490.6919860839844 301.0379943847656 C 490.9339904785156 300.6080017089844 491.1759948730469 300.177001953125 491.4240112304688 299.7510070800781 C 491.7009887695312 299.2730102539062 491.9819946289062 298.7969970703125 492.2690124511719 298.3250122070312 C 492.4700012207031 297.9949951171875 492.677001953125 297.6679992675781 492.8919982910156 297.3469848632812 C 493.1839904785156 296.9119873046875 493.4809875488281 296.4800109863281 493.7850036621094 296.0530090332031 C 494 295.7520141601562 494.2229919433594 295.4570007324219 494.4530029296875 295.1679992675781 C 494.7009887695312 294.8550109863281 494.9549865722656 294.5480041503906 495.2170104980469 294.2470092773438 C 495.4830017089844 293.9429931640625 495.7799987792969 293.6709899902344 496.10400390625 293.4280090332031 C 496.27099609375 293.3039855957031 496.4280090332031 293.1659851074219 496.5809936523438 293.0249938964844 C 496.7139892578125 292.9030151367188 496.8179931640625 292.7539978027344 496.8599853515625 292.5769958496094 C 496.9150085449219 292.3500061035156 496.8670043945312 292.1289978027344 496.7630004882812 291.9219970703125 C 496.6719970703125 291.739013671875 496.5369873046875 291.5929870605469 496.3380126953125 291.5339965820312 C 496.0161437988281 291.4370422363281 495.7000427246094 291.467041015625 495.3980102539062 291.6210021972656 C 495.1839904785156 291.7300109863281 495.0020141601562 291.8819885253906 494.8320007324219 292.0469970703125 C 494.3380126953125 292.5239868164062 493.9159851074219 293.06201171875 493.5130004882812 293.614013671875 C 493.2479858398438 293.9779968261719 492.9989929199219 294.3550109863281 492.75 294.7300109863281 C 492.4800109863281 295.1369934082031 492.2139892578125 295.5459899902344 491.9540100097656 295.9599914550781 C 491.6199951171875 296.4909973144531 491.2940063476562 297.0270080566406 490.9660034179688 297.56298828125 C 490.7439880371094 297.9249877929688 490.5239868164062 298.2879943847656 490.3049926757812 298.6520080566406 C 490.0740051269531 299.0350036621094 489.8460083007812 299.4200134277344 489.614990234375 299.8039855957031 C 489.4819946289062 300.0249938964844 489.3469848632812 300.2460021972656 489.2099914550781 300.4649963378906 C 489.1969909667969 300.4869995117188 489.1690063476562 300.4989929199219 489.1480102539062 300.5159912109375 C 489.1319885253906 300.4930114746094 489.1109924316406 300.4729919433594 489.1019897460938 300.447998046875 C 489.010986328125 300.197998046875 488.9230041503906 299.947998046875 488.8320007324219 299.697998046875 C 488.7030029296875 299.3460083007812 488.5700073242188 298.9960021972656 488.4440002441406 298.6430053710938 C 488.3380126953125 298.3489990234375 488.239990234375 298.0509948730469 488.135986328125 297.7560119628906 C 488.1119995117188 297.68701171875 488.0719909667969 297.6260070800781 487.9920043945312 297.6130065917969 C 487.8680114746094 297.5929870605469 487.7439880371094 297.5759887695312 487.656005859375 297.56298828125 C 487.5090026855469 297.5740051269531 487.3980102539062 297.572998046875 487.2909851074219 297.5920104980469 C 487.1279907226562 297.6210021972656 486.9639892578125 297.6520080566406 486.8070068359375 297.7030029296875 C 486.6400146484375 297.7569885253906 486.5339965820312 298.010986328125 486.5679931640625 298.1329956054688 C 486.625 298.3340148925781 486.6860046386719 298.5339965820312 486.7539978027344 298.7309875488281 C 486.8680114746094 299.0610046386719 486.9909973144531 299.3869934082031 487.1069946289062 299.7160034179688 C 487.1860046386719 299.9389953613281 487.260986328125 300.1650085449219 487.3380126953125 300.3890075683594 C 487.4100036621094 300.6029968261719 487.4859924316406 300.8150024414062 487.5530090332031 301.0299987792969 C 487.6369934082031 301.3039855957031 487.718994140625 301.5799865722656 487.7919921875 301.8569946289062 C 487.8420104980469 302.0450134277344 487.8810119628906 302.2359924316406 487.9140014648438 302.427001953125 C 487.9410095214844 302.5809936523438 487.9339904785156 302.7430114746094 488.0740051269531 302.85400390625 C 488.1000061035156 302.8739929199219 488.1220092773438 302.8999938964844 488.1449890136719 302.9240112304688 C 488.3080139160156 303.0960083007812 488.4859924316406 303.2479858398438 488.7120056152344 303.3309936523438 C 488.7785339355469 303.3553771972656 488.8478088378906 303.3721008300781 488.9154052734375 303.3721008300781 M 488.9154052734375 303.6627502441406 C 488.8192138671875 303.6627502441406 488.719970703125 303.6434936523438 488.6119384765625 303.6038818359375 C 488.3087158203125 303.4924926757812 488.0903625488281 303.2889099121094 487.9340515136719 303.1239624023438 L 487.9165649414062 303.1053466796875 C 487.9094543457031 303.0977172851562 487.9027099609375 303.0896911621094 487.8949584960938 303.0829162597656 C 487.6873779296875 302.9184265136719 487.6580200195312 302.6976623535156 487.6385803222656 302.5516052246094 C 487.63525390625 302.5267944335938 487.6320495605469 302.5018920898438 487.6277160644531 302.4772033691406 C 487.5921630859375 302.2713928222656 487.5540771484375 302.0932006835938 487.5111083984375 301.9317016601562 C 487.433837890625 301.6385192871094 487.3484802246094 301.3544616699219 487.2751159667969 301.1151733398438 C 487.2311096191406 300.9739990234375 487.1811218261719 300.8283996582031 487.1327514648438 300.6875915527344 C 487.1092224121094 300.6190490722656 487.0856628417969 300.5504760742188 487.0625305175781 300.481689453125 C 487.0360107421875 300.4045715332031 487.0091247558594 300.3253784179688 486.9822082519531 300.2461547851562 C 486.9330749511719 300.1014709472656 486.8839111328125 299.9566345214844 486.8330383300781 299.8130798339844 C 486.7825622558594 299.6699523925781 486.7309265136719 299.5278015136719 486.6792907714844 299.3856506347656 C 486.6129150390625 299.2029724121094 486.5442810058594 299.0140686035156 486.4792785644531 298.8258972167969 C 486.4154663085938 298.6410522460938 486.35302734375 298.4403686523438 486.2883605957031 298.2122802734375 C 486.2137145996094 297.9443664550781 486.3973388671875 297.5299682617188 486.7176208496094 297.4264221191406 C 486.8913879394531 297.3699645996094 487.0639343261719 297.337158203125 487.2400817871094 297.3058471679688 C 487.3291320800781 297.2900390625 487.4142456054688 297.2856140136719 487.5043640136719 297.2809448242188 C 487.5445861816406 297.2788696289062 487.5875244140625 297.2766418457031 487.63427734375 297.2731323242188 L 487.66650390625 297.2707214355469 L 487.7796630859375 297.2872314453125 C 487.8568420410156 297.29833984375 487.9476013183594 297.3114318847656 488.038330078125 297.3260803222656 C 488.1398315429688 297.3425598144531 488.3226623535156 297.4078674316406 488.4105224609375 297.6605529785156 C 488.4550170898438 297.7867431640625 488.4988403320312 297.9147033691406 488.5426330566406 298.0426635742188 C 488.5992126464844 298.2079162597656 488.65771484375 298.3787841796875 488.7174377441406 298.54443359375 C 488.7965698242188 298.7660827636719 488.8798522949219 298.9903259277344 488.9603881835938 299.2071533203125 C 489.0087280273438 299.3373413085938 489.0570983886719 299.467529296875 489.1049194335938 299.5979919433594 C 489.1420593261719 299.7000732421875 489.1786193847656 299.8017883300781 489.2149963378906 299.9034423828125 C 489.2639770507812 299.8230895996094 489.3141784667969 299.7401733398438 489.3659362792969 299.6541137695312 C 489.4731750488281 299.4758911132812 489.5797729492188 299.2974243164062 489.6863098144531 299.1190185546875 C 489.809326171875 298.9130554199219 489.9323120117188 298.7071838378906 490.0561218261719 298.5018920898438 C 490.2949523925781 298.1048583984375 490.5115966796875 297.7479248046875 490.7182312011719 297.4110412597656 L 490.8702087402344 297.1625366210938 C 491.142822265625 296.7166748046875 491.4246826171875 296.255615234375 491.7079772949219 295.8052368164062 C 491.9472961425781 295.4241027832031 492.2089538574219 295.019775390625 492.5077819824219 294.5693359375 L 492.5464477539062 294.5111083984375 C 492.7807312011719 294.1581420898438 493.0230102539062 293.7931823730469 493.2780151367188 293.4429321289062 C 493.6445007324219 292.9409484863281 494.0915222167969 292.3579406738281 494.6300964355469 291.8379211425781 C 494.8578186035156 291.6168823242188 495.0541381835938 291.469970703125 495.2660827636719 291.3619995117188 C 495.6339721679688 291.1744384765625 496.0304870605469 291.1378479003906 496.4218444824219 291.2556762695312 C 496.6780395507812 291.3316345214844 496.8864135742188 291.5174255371094 497.0232543945312 291.7925720214844 C 497.1689758300781 292.0825805664062 497.2092590332031 292.3699035644531 497.1424560546875 292.6454772949219 C 497.0904846191406 292.8645935058594 496.9675598144531 293.0648498535156 496.7774658203125 293.2391967773438 C 496.6457824707031 293.3605346679688 496.4694519042969 293.5186462402344 496.2773132324219 293.6613464355469 C 495.9656677246094 293.8950500488281 495.6821594238281 294.1567687988281 495.4357604980469 294.4383850097656 C 495.185791015625 294.7255554199219 494.931640625 295.0319519042969 494.6808166503906 295.3485107421875 C 494.4515686035156 295.6365356445312 494.2298889160156 295.9302368164062 494.0215148925781 296.2219543457031 C 493.7360229492188 296.6229248046875 493.4454040527344 297.0440368652344 493.1333312988281 297.5089721679688 C 492.9329223632812 297.8082275390625 492.7313232421875 298.1246643066406 492.5172424316406 298.4761962890625 C 492.2512817382812 298.91357421875 491.9758911132812 299.3782958984375 491.6755065917969 299.896728515625 C 491.4429016113281 300.2962646484375 491.2117004394531 300.7071228027344 490.9880981445312 301.1044616699219 L 490.9452819824219 301.1805419921875 C 490.8796691894531 301.2978210449219 490.8148193359375 301.4164733886719 490.7499084472656 301.5352172851562 C 490.6410217285156 301.7345275878906 490.5283813476562 301.9406127929688 490.4109802246094 302.1416015625 L 490.375732421875 302.2023315429688 C 490.1567993164062 302.5795593261719 489.930419921875 302.9696044921875 489.6004943847656 303.2995300292969 C 489.4853820800781 303.4159240722656 489.349609375 303.5173645019531 489.2090454101562 303.5918273925781 C 489.1195983886719 303.6389770507812 489.0209655761719 303.6627502441406 488.9154052734375 303.6627502441406 Z" stroke="none" fill="#fff"/>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                                Update items anytime
                              </li>
                              <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.87" height="14.789" viewBox="0 0 13.87 14.789">
                                  <g id="Grupo_6" data-name="Grupo 6" transform="translate(-483.304 -291.188)">
                                    <rect id="Rectángulo_4" data-name="Rectángulo 4" width="9.957" height="9.957" rx="2.883" transform="translate(483.909 295.414)" fill="#fff" stroke="#238359" stroke-miterlimit="10" stroke-width="1.211"/>
                                    <g id="BKPm3t.tif">
                                      <g id="Grupo_5" data-name="Grupo 5">
                                        <g id="Grupo_4" data-name="Grupo 4">
                                          <g id="Trazado_63" data-name="Trazado 63" fill="#238359" stroke-miterlimit="10">
                                            <path d="M 488.9154052734375 303.5174255371094 C 488.8366088867188 303.5174255371094 488.7536926269531 303.5010681152344 488.6619873046875 303.4674377441406 C 488.3871154785156 303.3664855957031 488.1849365234375 303.1774291992188 488.0395202636719 303.0239868164062 L 488.02294921875 303.00634765625 C 488.009033203125 302.9913940429688 487.9959106445312 302.9772644042969 487.9854125976562 302.9692077636719 C 487.8236999511719 302.8410034179688 487.8009033203125 302.669921875 487.7826232910156 302.5324401855469 C 487.779052734375 302.5056457519531 487.7755126953125 302.4787292480469 487.7708435058594 302.4521179199219 C 487.734619140625 302.2423706054688 487.6956176757812 302.06005859375 487.6515502929688 301.8943481445312 C 487.57373046875 301.5989990234375 487.4878234863281 301.313232421875 487.4140625 301.0726013183594 C 487.3692321777344 300.9287719726562 487.3188781738281 300.7821655273438 487.2702026367188 300.640380859375 C 487.2467651367188 300.5721130371094 487.2233276367188 300.5038452148438 487.2002868652344 300.4353332519531 C 487.1734924316406 300.3574829101562 487.1466674804688 300.2784729003906 487.1198120117188 300.1994323730469 C 487.0704650878906 300.0541076660156 487.0210876464844 299.90869140625 486.9700317382812 299.7645568847656 C 486.9194641113281 299.6211853027344 486.86767578125 299.4786071777344 486.8158569335938 299.3360290527344 C 486.7496948242188 299.1538696289062 486.6812744140625 298.9655151367188 486.6166381835938 298.7784423828125 C 486.5537414550781 298.5962219238281 486.4920959472656 298.3980712890625 486.4281921386719 298.1726379394531 C 486.3722839355469 297.9720458984375 486.5243835449219 297.6416320800781 486.7622985839844 297.5647277832031 C 486.927490234375 297.5110778808594 487.0946044921875 297.4793395996094 487.2655334472656 297.4489135742188 C 487.3456726074219 297.4346923828125 487.4264221191406 297.4305114746094 487.5118713378906 297.4260864257812 C 487.5531616210938 297.4239501953125 487.5971984863281 297.4216613769531 487.6451416015625 297.4180603027344 L 487.6612548828125 297.4168701171875 L 487.67724609375 297.4192199707031 L 487.7589721679688 297.4310913085938 C 487.8354187011719 297.4420776367188 487.92529296875 297.4550170898438 488.0151672363281 297.4695434570312 C 488.0999145507812 297.4833068847656 488.2133178710938 297.535888671875 488.2732543945312 297.7082824707031 C 488.3178100585938 297.8346557617188 488.3614807128906 297.9621887207031 488.4051513671875 298.0897521972656 C 488.4619140625 298.2555236816406 488.5205993652344 298.4269714355469 488.5807189941406 298.5937194824219 C 488.6600036621094 298.8158264160156 488.7434387207031 299.0404968261719 488.8241577148438 299.2577514648438 C 488.8724365234375 299.3877258300781 488.9207153320312 299.5177307128906 488.9684448242188 299.6480102539062 C 489.0142211914062 299.7737426757812 489.0591430664062 299.8992004394531 489.1040344238281 300.0246276855469 C 489.1294555664062 300.0956115722656 489.1548461914062 300.1665649414062 489.1803894042969 300.2375183105469 C 489.2795104980469 300.0774230957031 489.3815002441406 299.91015625 489.490478515625 299.7290649414062 C 489.5977783203125 299.5506896972656 489.7044677734375 299.3720703125 489.8110961914062 299.1935424804688 C 489.9339904785156 298.9877624511719 490.0568542480469 298.7820739746094 490.1805419921875 298.5769653320312 C 490.4192810058594 298.1801147460938 490.6357116699219 297.8235473632812 490.8421325683594 297.4869995117188 L 490.9942016601562 297.2383422851562 C 491.2665710449219 296.7928466796875 491.5481872558594 296.3322143554688 491.8309936523438 295.8825988769531 C 492.0697326660156 295.50244140625 492.3307495117188 295.09912109375 492.62890625 294.649658203125 L 492.6675109863281 294.5914916992188 C 492.9009704589844 294.2398376464844 493.142333984375 293.8761901855469 493.3955078125 293.5284729003906 C 493.7582092285156 293.0316467285156 494.200439453125 292.4548034667969 494.7310485839844 291.9424438476562 C 494.9481811523438 291.7317504882812 495.1336059570312 291.5925903320312 495.3320617675781 291.4915161132812 C 495.5383605957031 291.3863220214844 495.7532043457031 291.3329467773438 495.9705505371094 291.3329467773438 C 496.1058044433594 291.3329467773438 496.2435607910156 291.353759765625 496.3799133300781 291.3948364257812 C 496.6001586914062 291.4601440429688 496.7730102539062 291.6157836914062 496.8931274414062 291.8572998046875 C 497.0232238769531 292.1162109375 497.0596923828125 292.3700561523438 497.001220703125 292.6112365722656 C 496.9559020996094 292.8022766113281 496.8475036621094 292.9777526855469 496.6792297363281 293.1321105957031 C 496.5499267578125 293.2512512207031 496.3773193359375 293.4060668945312 496.1906433105469 293.544677734375 C 495.8704223632812 293.7848510742188 495.5794372558594 294.053466796875 495.3263854980469 294.3427124023438 C 495.07470703125 294.6318054199219 494.8191223144531 294.93994140625 494.5669250488281 295.2582397460938 C 494.3363037109375 295.5479736328125 494.1130981445312 295.8437194824219 493.9032592773438 296.1374816894531 C 493.6168823242188 296.5397338867188 493.3255004882812 296.9619140625 493.0126647949219 297.427978515625 C 492.8109741210938 297.7290954589844 492.6083068847656 298.0473022460938 492.3931274414062 298.4006042480469 C 492.1265563964844 298.8389587402344 491.8506774902344 299.3045349121094 491.5497436523438 299.8238525390625 C 491.3167724609375 300.2240905761719 491.0852966308594 300.6354064941406 490.8614501953125 301.0331726074219 L 490.8186340332031 301.1092834472656 C 490.7525939941406 301.2272338867188 490.6875305175781 301.3463745117188 490.6223754882812 301.4655456542969 C 490.5139770507812 301.6639404296875 490.40185546875 301.8691101074219 490.2854919433594 302.0682983398438 L 490.2500305175781 302.1293640136719 C 490.0357971191406 302.49853515625 489.8142395019531 302.8802795410156 489.4977416992188 303.1967468261719 C 489.3922729492188 303.3033752441406 489.2687377929688 303.395751953125 489.1410217285156 303.4634094238281 C 489.0729370117188 303.4992980957031 488.9971008300781 303.5174255371094 488.9154052734375 303.5174255371094 Z" stroke="none"/>
                                            <path d="M 488.9154052734375 303.3721008300781 C 488.9697875976562 303.3721008300781 489.0230712890625 303.3612976074219 489.072998046875 303.3349914550781 C 489.1900024414062 303.2730102539062 489.3009948730469 303.1889953613281 489.3949890136719 303.093994140625 C 489.7149963378906 302.7739868164062 489.9349975585938 302.3819885253906 490.1600036621094 301.9949951171875 C 490.343994140625 301.6799926757812 490.5140075683594 301.3559875488281 490.6919860839844 301.0379943847656 C 490.9339904785156 300.6080017089844 491.1759948730469 300.177001953125 491.4240112304688 299.7510070800781 C 491.7009887695312 299.2730102539062 491.9819946289062 298.7969970703125 492.2690124511719 298.3250122070312 C 492.4700012207031 297.9949951171875 492.677001953125 297.6679992675781 492.8919982910156 297.3469848632812 C 493.1839904785156 296.9119873046875 493.4809875488281 296.4800109863281 493.7850036621094 296.0530090332031 C 494 295.7520141601562 494.2229919433594 295.4570007324219 494.4530029296875 295.1679992675781 C 494.7009887695312 294.8550109863281 494.9549865722656 294.5480041503906 495.2170104980469 294.2470092773438 C 495.4830017089844 293.9429931640625 495.7799987792969 293.6709899902344 496.10400390625 293.4280090332031 C 496.27099609375 293.3039855957031 496.4280090332031 293.1659851074219 496.5809936523438 293.0249938964844 C 496.7139892578125 292.9030151367188 496.8179931640625 292.7539978027344 496.8599853515625 292.5769958496094 C 496.9150085449219 292.3500061035156 496.8670043945312 292.1289978027344 496.7630004882812 291.9219970703125 C 496.6719970703125 291.739013671875 496.5369873046875 291.5929870605469 496.3380126953125 291.5339965820312 C 496.0161437988281 291.4370422363281 495.7000427246094 291.467041015625 495.3980102539062 291.6210021972656 C 495.1839904785156 291.7300109863281 495.0020141601562 291.8819885253906 494.8320007324219 292.0469970703125 C 494.3380126953125 292.5239868164062 493.9159851074219 293.06201171875 493.5130004882812 293.614013671875 C 493.2479858398438 293.9779968261719 492.9989929199219 294.3550109863281 492.75 294.7300109863281 C 492.4800109863281 295.1369934082031 492.2139892578125 295.5459899902344 491.9540100097656 295.9599914550781 C 491.6199951171875 296.4909973144531 491.2940063476562 297.0270080566406 490.9660034179688 297.56298828125 C 490.7439880371094 297.9249877929688 490.5239868164062 298.2879943847656 490.3049926757812 298.6520080566406 C 490.0740051269531 299.0350036621094 489.8460083007812 299.4200134277344 489.614990234375 299.8039855957031 C 489.4819946289062 300.0249938964844 489.3469848632812 300.2460021972656 489.2099914550781 300.4649963378906 C 489.1969909667969 300.4869995117188 489.1690063476562 300.4989929199219 489.1480102539062 300.5159912109375 C 489.1319885253906 300.4930114746094 489.1109924316406 300.4729919433594 489.1019897460938 300.447998046875 C 489.010986328125 300.197998046875 488.9230041503906 299.947998046875 488.8320007324219 299.697998046875 C 488.7030029296875 299.3460083007812 488.5700073242188 298.9960021972656 488.4440002441406 298.6430053710938 C 488.3380126953125 298.3489990234375 488.239990234375 298.0509948730469 488.135986328125 297.7560119628906 C 488.1119995117188 297.68701171875 488.0719909667969 297.6260070800781 487.9920043945312 297.6130065917969 C 487.8680114746094 297.5929870605469 487.7439880371094 297.5759887695312 487.656005859375 297.56298828125 C 487.5090026855469 297.5740051269531 487.3980102539062 297.572998046875 487.2909851074219 297.5920104980469 C 487.1279907226562 297.6210021972656 486.9639892578125 297.6520080566406 486.8070068359375 297.7030029296875 C 486.6400146484375 297.7569885253906 486.5339965820312 298.010986328125 486.5679931640625 298.1329956054688 C 486.625 298.3340148925781 486.6860046386719 298.5339965820312 486.7539978027344 298.7309875488281 C 486.8680114746094 299.0610046386719 486.9909973144531 299.3869934082031 487.1069946289062 299.7160034179688 C 487.1860046386719 299.9389953613281 487.260986328125 300.1650085449219 487.3380126953125 300.3890075683594 C 487.4100036621094 300.6029968261719 487.4859924316406 300.8150024414062 487.5530090332031 301.0299987792969 C 487.6369934082031 301.3039855957031 487.718994140625 301.5799865722656 487.7919921875 301.8569946289062 C 487.8420104980469 302.0450134277344 487.8810119628906 302.2359924316406 487.9140014648438 302.427001953125 C 487.9410095214844 302.5809936523438 487.9339904785156 302.7430114746094 488.0740051269531 302.85400390625 C 488.1000061035156 302.8739929199219 488.1220092773438 302.8999938964844 488.1449890136719 302.9240112304688 C 488.3080139160156 303.0960083007812 488.4859924316406 303.2479858398438 488.7120056152344 303.3309936523438 C 488.7785339355469 303.3553771972656 488.8478088378906 303.3721008300781 488.9154052734375 303.3721008300781 M 488.9154052734375 303.6627502441406 C 488.8192138671875 303.6627502441406 488.719970703125 303.6434936523438 488.6119384765625 303.6038818359375 C 488.3087158203125 303.4924926757812 488.0903625488281 303.2889099121094 487.9340515136719 303.1239624023438 L 487.9165649414062 303.1053466796875 C 487.9094543457031 303.0977172851562 487.9027099609375 303.0896911621094 487.8949584960938 303.0829162597656 C 487.6873779296875 302.9184265136719 487.6580200195312 302.6976623535156 487.6385803222656 302.5516052246094 C 487.63525390625 302.5267944335938 487.6320495605469 302.5018920898438 487.6277160644531 302.4772033691406 C 487.5921630859375 302.2713928222656 487.5540771484375 302.0932006835938 487.5111083984375 301.9317016601562 C 487.433837890625 301.6385192871094 487.3484802246094 301.3544616699219 487.2751159667969 301.1151733398438 C 487.2311096191406 300.9739990234375 487.1811218261719 300.8283996582031 487.1327514648438 300.6875915527344 C 487.1092224121094 300.6190490722656 487.0856628417969 300.5504760742188 487.0625305175781 300.481689453125 C 487.0360107421875 300.4045715332031 487.0091247558594 300.3253784179688 486.9822082519531 300.2461547851562 C 486.9330749511719 300.1014709472656 486.8839111328125 299.9566345214844 486.8330383300781 299.8130798339844 C 486.7825622558594 299.6699523925781 486.7309265136719 299.5278015136719 486.6792907714844 299.3856506347656 C 486.6129150390625 299.2029724121094 486.5442810058594 299.0140686035156 486.4792785644531 298.8258972167969 C 486.4154663085938 298.6410522460938 486.35302734375 298.4403686523438 486.2883605957031 298.2122802734375 C 486.2137145996094 297.9443664550781 486.3973388671875 297.5299682617188 486.7176208496094 297.4264221191406 C 486.8913879394531 297.3699645996094 487.0639343261719 297.337158203125 487.2400817871094 297.3058471679688 C 487.3291320800781 297.2900390625 487.4142456054688 297.2856140136719 487.5043640136719 297.2809448242188 C 487.5445861816406 297.2788696289062 487.5875244140625 297.2766418457031 487.63427734375 297.2731323242188 L 487.66650390625 297.2707214355469 L 487.7796630859375 297.2872314453125 C 487.8568420410156 297.29833984375 487.9476013183594 297.3114318847656 488.038330078125 297.3260803222656 C 488.1398315429688 297.3425598144531 488.3226623535156 297.4078674316406 488.4105224609375 297.6605529785156 C 488.4550170898438 297.7867431640625 488.4988403320312 297.9147033691406 488.5426330566406 298.0426635742188 C 488.5992126464844 298.2079162597656 488.65771484375 298.3787841796875 488.7174377441406 298.54443359375 C 488.7965698242188 298.7660827636719 488.8798522949219 298.9903259277344 488.9603881835938 299.2071533203125 C 489.0087280273438 299.3373413085938 489.0570983886719 299.467529296875 489.1049194335938 299.5979919433594 C 489.1420593261719 299.7000732421875 489.1786193847656 299.8017883300781 489.2149963378906 299.9034423828125 C 489.2639770507812 299.8230895996094 489.3141784667969 299.7401733398438 489.3659362792969 299.6541137695312 C 489.4731750488281 299.4758911132812 489.5797729492188 299.2974243164062 489.6863098144531 299.1190185546875 C 489.809326171875 298.9130554199219 489.9323120117188 298.7071838378906 490.0561218261719 298.5018920898438 C 490.2949523925781 298.1048583984375 490.5115966796875 297.7479248046875 490.7182312011719 297.4110412597656 L 490.8702087402344 297.1625366210938 C 491.142822265625 296.7166748046875 491.4246826171875 296.255615234375 491.7079772949219 295.8052368164062 C 491.9472961425781 295.4241027832031 492.2089538574219 295.019775390625 492.5077819824219 294.5693359375 L 492.5464477539062 294.5111083984375 C 492.7807312011719 294.1581420898438 493.0230102539062 293.7931823730469 493.2780151367188 293.4429321289062 C 493.6445007324219 292.9409484863281 494.0915222167969 292.3579406738281 494.6300964355469 291.8379211425781 C 494.8578186035156 291.6168823242188 495.0541381835938 291.469970703125 495.2660827636719 291.3619995117188 C 495.6339721679688 291.1744384765625 496.0304870605469 291.1378479003906 496.4218444824219 291.2556762695312 C 496.6780395507812 291.3316345214844 496.8864135742188 291.5174255371094 497.0232543945312 291.7925720214844 C 497.1689758300781 292.0825805664062 497.2092590332031 292.3699035644531 497.1424560546875 292.6454772949219 C 497.0904846191406 292.8645935058594 496.9675598144531 293.0648498535156 496.7774658203125 293.2391967773438 C 496.6457824707031 293.3605346679688 496.4694519042969 293.5186462402344 496.2773132324219 293.6613464355469 C 495.9656677246094 293.8950500488281 495.6821594238281 294.1567687988281 495.4357604980469 294.4383850097656 C 495.185791015625 294.7255554199219 494.931640625 295.0319519042969 494.6808166503906 295.3485107421875 C 494.4515686035156 295.6365356445312 494.2298889160156 295.9302368164062 494.0215148925781 296.2219543457031 C 493.7360229492188 296.6229248046875 493.4454040527344 297.0440368652344 493.1333312988281 297.5089721679688 C 492.9329223632812 297.8082275390625 492.7313232421875 298.1246643066406 492.5172424316406 298.4761962890625 C 492.2512817382812 298.91357421875 491.9758911132812 299.3782958984375 491.6755065917969 299.896728515625 C 491.4429016113281 300.2962646484375 491.2117004394531 300.7071228027344 490.9880981445312 301.1044616699219 L 490.9452819824219 301.1805419921875 C 490.8796691894531 301.2978210449219 490.8148193359375 301.4164733886719 490.7499084472656 301.5352172851562 C 490.6410217285156 301.7345275878906 490.5283813476562 301.9406127929688 490.4109802246094 302.1416015625 L 490.375732421875 302.2023315429688 C 490.1567993164062 302.5795593261719 489.930419921875 302.9696044921875 489.6004943847656 303.2995300292969 C 489.4853820800781 303.4159240722656 489.349609375 303.5173645019531 489.2090454101562 303.5918273925781 C 489.1195983886719 303.6389770507812 489.0209655761719 303.6627502441406 488.9154052734375 303.6627502441406 Z" stroke="none" fill="#fff"/>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                                Skip or Cancel Anytime
                              </li>
                              <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13.87" height="14.789" viewBox="0 0 13.87 14.789">
                                  <g id="Grupo_6" data-name="Grupo 6" transform="translate(-483.304 -291.188)">
                                    <rect id="Rectángulo_4" data-name="Rectángulo 4" width="9.957" height="9.957" rx="2.883" transform="translate(483.909 295.414)" fill="#fff" stroke="#238359" stroke-miterlimit="10" stroke-width="1.211"/>
                                    <g id="BKPm3t.tif">
                                      <g id="Grupo_5" data-name="Grupo 5">
                                        <g id="Grupo_4" data-name="Grupo 4">
                                          <g id="Trazado_63" data-name="Trazado 63" fill="#238359" stroke-miterlimit="10">
                                            <path d="M 488.9154052734375 303.5174255371094 C 488.8366088867188 303.5174255371094 488.7536926269531 303.5010681152344 488.6619873046875 303.4674377441406 C 488.3871154785156 303.3664855957031 488.1849365234375 303.1774291992188 488.0395202636719 303.0239868164062 L 488.02294921875 303.00634765625 C 488.009033203125 302.9913940429688 487.9959106445312 302.9772644042969 487.9854125976562 302.9692077636719 C 487.8236999511719 302.8410034179688 487.8009033203125 302.669921875 487.7826232910156 302.5324401855469 C 487.779052734375 302.5056457519531 487.7755126953125 302.4787292480469 487.7708435058594 302.4521179199219 C 487.734619140625 302.2423706054688 487.6956176757812 302.06005859375 487.6515502929688 301.8943481445312 C 487.57373046875 301.5989990234375 487.4878234863281 301.313232421875 487.4140625 301.0726013183594 C 487.3692321777344 300.9287719726562 487.3188781738281 300.7821655273438 487.2702026367188 300.640380859375 C 487.2467651367188 300.5721130371094 487.2233276367188 300.5038452148438 487.2002868652344 300.4353332519531 C 487.1734924316406 300.3574829101562 487.1466674804688 300.2784729003906 487.1198120117188 300.1994323730469 C 487.0704650878906 300.0541076660156 487.0210876464844 299.90869140625 486.9700317382812 299.7645568847656 C 486.9194641113281 299.6211853027344 486.86767578125 299.4786071777344 486.8158569335938 299.3360290527344 C 486.7496948242188 299.1538696289062 486.6812744140625 298.9655151367188 486.6166381835938 298.7784423828125 C 486.5537414550781 298.5962219238281 486.4920959472656 298.3980712890625 486.4281921386719 298.1726379394531 C 486.3722839355469 297.9720458984375 486.5243835449219 297.6416320800781 486.7622985839844 297.5647277832031 C 486.927490234375 297.5110778808594 487.0946044921875 297.4793395996094 487.2655334472656 297.4489135742188 C 487.3456726074219 297.4346923828125 487.4264221191406 297.4305114746094 487.5118713378906 297.4260864257812 C 487.5531616210938 297.4239501953125 487.5971984863281 297.4216613769531 487.6451416015625 297.4180603027344 L 487.6612548828125 297.4168701171875 L 487.67724609375 297.4192199707031 L 487.7589721679688 297.4310913085938 C 487.8354187011719 297.4420776367188 487.92529296875 297.4550170898438 488.0151672363281 297.4695434570312 C 488.0999145507812 297.4833068847656 488.2133178710938 297.535888671875 488.2732543945312 297.7082824707031 C 488.3178100585938 297.8346557617188 488.3614807128906 297.9621887207031 488.4051513671875 298.0897521972656 C 488.4619140625 298.2555236816406 488.5205993652344 298.4269714355469 488.5807189941406 298.5937194824219 C 488.6600036621094 298.8158264160156 488.7434387207031 299.0404968261719 488.8241577148438 299.2577514648438 C 488.8724365234375 299.3877258300781 488.9207153320312 299.5177307128906 488.9684448242188 299.6480102539062 C 489.0142211914062 299.7737426757812 489.0591430664062 299.8992004394531 489.1040344238281 300.0246276855469 C 489.1294555664062 300.0956115722656 489.1548461914062 300.1665649414062 489.1803894042969 300.2375183105469 C 489.2795104980469 300.0774230957031 489.3815002441406 299.91015625 489.490478515625 299.7290649414062 C 489.5977783203125 299.5506896972656 489.7044677734375 299.3720703125 489.8110961914062 299.1935424804688 C 489.9339904785156 298.9877624511719 490.0568542480469 298.7820739746094 490.1805419921875 298.5769653320312 C 490.4192810058594 298.1801147460938 490.6357116699219 297.8235473632812 490.8421325683594 297.4869995117188 L 490.9942016601562 297.2383422851562 C 491.2665710449219 296.7928466796875 491.5481872558594 296.3322143554688 491.8309936523438 295.8825988769531 C 492.0697326660156 295.50244140625 492.3307495117188 295.09912109375 492.62890625 294.649658203125 L 492.6675109863281 294.5914916992188 C 492.9009704589844 294.2398376464844 493.142333984375 293.8761901855469 493.3955078125 293.5284729003906 C 493.7582092285156 293.0316467285156 494.200439453125 292.4548034667969 494.7310485839844 291.9424438476562 C 494.9481811523438 291.7317504882812 495.1336059570312 291.5925903320312 495.3320617675781 291.4915161132812 C 495.5383605957031 291.3863220214844 495.7532043457031 291.3329467773438 495.9705505371094 291.3329467773438 C 496.1058044433594 291.3329467773438 496.2435607910156 291.353759765625 496.3799133300781 291.3948364257812 C 496.6001586914062 291.4601440429688 496.7730102539062 291.6157836914062 496.8931274414062 291.8572998046875 C 497.0232238769531 292.1162109375 497.0596923828125 292.3700561523438 497.001220703125 292.6112365722656 C 496.9559020996094 292.8022766113281 496.8475036621094 292.9777526855469 496.6792297363281 293.1321105957031 C 496.5499267578125 293.2512512207031 496.3773193359375 293.4060668945312 496.1906433105469 293.544677734375 C 495.8704223632812 293.7848510742188 495.5794372558594 294.053466796875 495.3263854980469 294.3427124023438 C 495.07470703125 294.6318054199219 494.8191223144531 294.93994140625 494.5669250488281 295.2582397460938 C 494.3363037109375 295.5479736328125 494.1130981445312 295.8437194824219 493.9032592773438 296.1374816894531 C 493.6168823242188 296.5397338867188 493.3255004882812 296.9619140625 493.0126647949219 297.427978515625 C 492.8109741210938 297.7290954589844 492.6083068847656 298.0473022460938 492.3931274414062 298.4006042480469 C 492.1265563964844 298.8389587402344 491.8506774902344 299.3045349121094 491.5497436523438 299.8238525390625 C 491.3167724609375 300.2240905761719 491.0852966308594 300.6354064941406 490.8614501953125 301.0331726074219 L 490.8186340332031 301.1092834472656 C 490.7525939941406 301.2272338867188 490.6875305175781 301.3463745117188 490.6223754882812 301.4655456542969 C 490.5139770507812 301.6639404296875 490.40185546875 301.8691101074219 490.2854919433594 302.0682983398438 L 490.2500305175781 302.1293640136719 C 490.0357971191406 302.49853515625 489.8142395019531 302.8802795410156 489.4977416992188 303.1967468261719 C 489.3922729492188 303.3033752441406 489.2687377929688 303.395751953125 489.1410217285156 303.4634094238281 C 489.0729370117188 303.4992980957031 488.9971008300781 303.5174255371094 488.9154052734375 303.5174255371094 Z" stroke="none"/>
                                            <path d="M 488.9154052734375 303.3721008300781 C 488.9697875976562 303.3721008300781 489.0230712890625 303.3612976074219 489.072998046875 303.3349914550781 C 489.1900024414062 303.2730102539062 489.3009948730469 303.1889953613281 489.3949890136719 303.093994140625 C 489.7149963378906 302.7739868164062 489.9349975585938 302.3819885253906 490.1600036621094 301.9949951171875 C 490.343994140625 301.6799926757812 490.5140075683594 301.3559875488281 490.6919860839844 301.0379943847656 C 490.9339904785156 300.6080017089844 491.1759948730469 300.177001953125 491.4240112304688 299.7510070800781 C 491.7009887695312 299.2730102539062 491.9819946289062 298.7969970703125 492.2690124511719 298.3250122070312 C 492.4700012207031 297.9949951171875 492.677001953125 297.6679992675781 492.8919982910156 297.3469848632812 C 493.1839904785156 296.9119873046875 493.4809875488281 296.4800109863281 493.7850036621094 296.0530090332031 C 494 295.7520141601562 494.2229919433594 295.4570007324219 494.4530029296875 295.1679992675781 C 494.7009887695312 294.8550109863281 494.9549865722656 294.5480041503906 495.2170104980469 294.2470092773438 C 495.4830017089844 293.9429931640625 495.7799987792969 293.6709899902344 496.10400390625 293.4280090332031 C 496.27099609375 293.3039855957031 496.4280090332031 293.1659851074219 496.5809936523438 293.0249938964844 C 496.7139892578125 292.9030151367188 496.8179931640625 292.7539978027344 496.8599853515625 292.5769958496094 C 496.9150085449219 292.3500061035156 496.8670043945312 292.1289978027344 496.7630004882812 291.9219970703125 C 496.6719970703125 291.739013671875 496.5369873046875 291.5929870605469 496.3380126953125 291.5339965820312 C 496.0161437988281 291.4370422363281 495.7000427246094 291.467041015625 495.3980102539062 291.6210021972656 C 495.1839904785156 291.7300109863281 495.0020141601562 291.8819885253906 494.8320007324219 292.0469970703125 C 494.3380126953125 292.5239868164062 493.9159851074219 293.06201171875 493.5130004882812 293.614013671875 C 493.2479858398438 293.9779968261719 492.9989929199219 294.3550109863281 492.75 294.7300109863281 C 492.4800109863281 295.1369934082031 492.2139892578125 295.5459899902344 491.9540100097656 295.9599914550781 C 491.6199951171875 296.4909973144531 491.2940063476562 297.0270080566406 490.9660034179688 297.56298828125 C 490.7439880371094 297.9249877929688 490.5239868164062 298.2879943847656 490.3049926757812 298.6520080566406 C 490.0740051269531 299.0350036621094 489.8460083007812 299.4200134277344 489.614990234375 299.8039855957031 C 489.4819946289062 300.0249938964844 489.3469848632812 300.2460021972656 489.2099914550781 300.4649963378906 C 489.1969909667969 300.4869995117188 489.1690063476562 300.4989929199219 489.1480102539062 300.5159912109375 C 489.1319885253906 300.4930114746094 489.1109924316406 300.4729919433594 489.1019897460938 300.447998046875 C 489.010986328125 300.197998046875 488.9230041503906 299.947998046875 488.8320007324219 299.697998046875 C 488.7030029296875 299.3460083007812 488.5700073242188 298.9960021972656 488.4440002441406 298.6430053710938 C 488.3380126953125 298.3489990234375 488.239990234375 298.0509948730469 488.135986328125 297.7560119628906 C 488.1119995117188 297.68701171875 488.0719909667969 297.6260070800781 487.9920043945312 297.6130065917969 C 487.8680114746094 297.5929870605469 487.7439880371094 297.5759887695312 487.656005859375 297.56298828125 C 487.5090026855469 297.5740051269531 487.3980102539062 297.572998046875 487.2909851074219 297.5920104980469 C 487.1279907226562 297.6210021972656 486.9639892578125 297.6520080566406 486.8070068359375 297.7030029296875 C 486.6400146484375 297.7569885253906 486.5339965820312 298.010986328125 486.5679931640625 298.1329956054688 C 486.625 298.3340148925781 486.6860046386719 298.5339965820312 486.7539978027344 298.7309875488281 C 486.8680114746094 299.0610046386719 486.9909973144531 299.3869934082031 487.1069946289062 299.7160034179688 C 487.1860046386719 299.9389953613281 487.260986328125 300.1650085449219 487.3380126953125 300.3890075683594 C 487.4100036621094 300.6029968261719 487.4859924316406 300.8150024414062 487.5530090332031 301.0299987792969 C 487.6369934082031 301.3039855957031 487.718994140625 301.5799865722656 487.7919921875 301.8569946289062 C 487.8420104980469 302.0450134277344 487.8810119628906 302.2359924316406 487.9140014648438 302.427001953125 C 487.9410095214844 302.5809936523438 487.9339904785156 302.7430114746094 488.0740051269531 302.85400390625 C 488.1000061035156 302.8739929199219 488.1220092773438 302.8999938964844 488.1449890136719 302.9240112304688 C 488.3080139160156 303.0960083007812 488.4859924316406 303.2479858398438 488.7120056152344 303.3309936523438 C 488.7785339355469 303.3553771972656 488.8478088378906 303.3721008300781 488.9154052734375 303.3721008300781 M 488.9154052734375 303.6627502441406 C 488.8192138671875 303.6627502441406 488.719970703125 303.6434936523438 488.6119384765625 303.6038818359375 C 488.3087158203125 303.4924926757812 488.0903625488281 303.2889099121094 487.9340515136719 303.1239624023438 L 487.9165649414062 303.1053466796875 C 487.9094543457031 303.0977172851562 487.9027099609375 303.0896911621094 487.8949584960938 303.0829162597656 C 487.6873779296875 302.9184265136719 487.6580200195312 302.6976623535156 487.6385803222656 302.5516052246094 C 487.63525390625 302.5267944335938 487.6320495605469 302.5018920898438 487.6277160644531 302.4772033691406 C 487.5921630859375 302.2713928222656 487.5540771484375 302.0932006835938 487.5111083984375 301.9317016601562 C 487.433837890625 301.6385192871094 487.3484802246094 301.3544616699219 487.2751159667969 301.1151733398438 C 487.2311096191406 300.9739990234375 487.1811218261719 300.8283996582031 487.1327514648438 300.6875915527344 C 487.1092224121094 300.6190490722656 487.0856628417969 300.5504760742188 487.0625305175781 300.481689453125 C 487.0360107421875 300.4045715332031 487.0091247558594 300.3253784179688 486.9822082519531 300.2461547851562 C 486.9330749511719 300.1014709472656 486.8839111328125 299.9566345214844 486.8330383300781 299.8130798339844 C 486.7825622558594 299.6699523925781 486.7309265136719 299.5278015136719 486.6792907714844 299.3856506347656 C 486.6129150390625 299.2029724121094 486.5442810058594 299.0140686035156 486.4792785644531 298.8258972167969 C 486.4154663085938 298.6410522460938 486.35302734375 298.4403686523438 486.2883605957031 298.2122802734375 C 486.2137145996094 297.9443664550781 486.3973388671875 297.5299682617188 486.7176208496094 297.4264221191406 C 486.8913879394531 297.3699645996094 487.0639343261719 297.337158203125 487.2400817871094 297.3058471679688 C 487.3291320800781 297.2900390625 487.4142456054688 297.2856140136719 487.5043640136719 297.2809448242188 C 487.5445861816406 297.2788696289062 487.5875244140625 297.2766418457031 487.63427734375 297.2731323242188 L 487.66650390625 297.2707214355469 L 487.7796630859375 297.2872314453125 C 487.8568420410156 297.29833984375 487.9476013183594 297.3114318847656 488.038330078125 297.3260803222656 C 488.1398315429688 297.3425598144531 488.3226623535156 297.4078674316406 488.4105224609375 297.6605529785156 C 488.4550170898438 297.7867431640625 488.4988403320312 297.9147033691406 488.5426330566406 298.0426635742188 C 488.5992126464844 298.2079162597656 488.65771484375 298.3787841796875 488.7174377441406 298.54443359375 C 488.7965698242188 298.7660827636719 488.8798522949219 298.9903259277344 488.9603881835938 299.2071533203125 C 489.0087280273438 299.3373413085938 489.0570983886719 299.467529296875 489.1049194335938 299.5979919433594 C 489.1420593261719 299.7000732421875 489.1786193847656 299.8017883300781 489.2149963378906 299.9034423828125 C 489.2639770507812 299.8230895996094 489.3141784667969 299.7401733398438 489.3659362792969 299.6541137695312 C 489.4731750488281 299.4758911132812 489.5797729492188 299.2974243164062 489.6863098144531 299.1190185546875 C 489.809326171875 298.9130554199219 489.9323120117188 298.7071838378906 490.0561218261719 298.5018920898438 C 490.2949523925781 298.1048583984375 490.5115966796875 297.7479248046875 490.7182312011719 297.4110412597656 L 490.8702087402344 297.1625366210938 C 491.142822265625 296.7166748046875 491.4246826171875 296.255615234375 491.7079772949219 295.8052368164062 C 491.9472961425781 295.4241027832031 492.2089538574219 295.019775390625 492.5077819824219 294.5693359375 L 492.5464477539062 294.5111083984375 C 492.7807312011719 294.1581420898438 493.0230102539062 293.7931823730469 493.2780151367188 293.4429321289062 C 493.6445007324219 292.9409484863281 494.0915222167969 292.3579406738281 494.6300964355469 291.8379211425781 C 494.8578186035156 291.6168823242188 495.0541381835938 291.469970703125 495.2660827636719 291.3619995117188 C 495.6339721679688 291.1744384765625 496.0304870605469 291.1378479003906 496.4218444824219 291.2556762695312 C 496.6780395507812 291.3316345214844 496.8864135742188 291.5174255371094 497.0232543945312 291.7925720214844 C 497.1689758300781 292.0825805664062 497.2092590332031 292.3699035644531 497.1424560546875 292.6454772949219 C 497.0904846191406 292.8645935058594 496.9675598144531 293.0648498535156 496.7774658203125 293.2391967773438 C 496.6457824707031 293.3605346679688 496.4694519042969 293.5186462402344 496.2773132324219 293.6613464355469 C 495.9656677246094 293.8950500488281 495.6821594238281 294.1567687988281 495.4357604980469 294.4383850097656 C 495.185791015625 294.7255554199219 494.931640625 295.0319519042969 494.6808166503906 295.3485107421875 C 494.4515686035156 295.6365356445312 494.2298889160156 295.9302368164062 494.0215148925781 296.2219543457031 C 493.7360229492188 296.6229248046875 493.4454040527344 297.0440368652344 493.1333312988281 297.5089721679688 C 492.9329223632812 297.8082275390625 492.7313232421875 298.1246643066406 492.5172424316406 298.4761962890625 C 492.2512817382812 298.91357421875 491.9758911132812 299.3782958984375 491.6755065917969 299.896728515625 C 491.4429016113281 300.2962646484375 491.2117004394531 300.7071228027344 490.9880981445312 301.1044616699219 L 490.9452819824219 301.1805419921875 C 490.8796691894531 301.2978210449219 490.8148193359375 301.4164733886719 490.7499084472656 301.5352172851562 C 490.6410217285156 301.7345275878906 490.5283813476562 301.9406127929688 490.4109802246094 302.1416015625 L 490.375732421875 302.2023315429688 C 490.1567993164062 302.5795593261719 489.930419921875 302.9696044921875 489.6004943847656 303.2995300292969 C 489.4853820800781 303.4159240722656 489.349609375 303.5173645019531 489.2090454101562 303.5918273925781 C 489.1195983886719 303.6389770507812 489.0209655761719 303.6627502441406 488.9154052734375 303.6627502441406 Z" stroke="none" fill="#fff"/>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                                Early access new items
                              </li>
                            </ul>`,
                      showCancelButton: true,
                      confirmButtonText: 'Yes',
                      confirmButtonClass: 'btn',
                      cancelButtonText: 'No',
                      cancelButtonClass: 'btn',
                      customClass: {
                        container: 'swalBYOBPopups'
                      }
                    }).then((result) => {
                      $('.build-your-kit--is-loading').show();
                      if (result.isConfirmed) {
                        $('.cart__checkout').removeAttr('disabled').removeClass('disabled');
                        $('#byob_purchase_type_autodeliver-side').attr('goToCheckout',true);
                        $('#byob_purchase_type_autodeliver-side').trigger('click');
                        event.preventDefault();
                        return false;
                      } else {
                        goToCheckout(cartSubscription,isResult.cart);
                      }
                    })
                  } else {
                    $('.build-your-kit--is-loading').show();
                    goToCheckout(cartSubscription,isResult.cart);
                  }
                } else {
                  $('.build-your-kit--is-loading').show();
                  goToCheckout(cartSubscription,isResult.cart);
                }
                /*
                console.log('isAllOneTime',isAllOneTime,'isBYOB',isBYOB);
                if (isAllOneTime == true && isBYOB == false) {
                  console.log('Sorry, you have added non-subscription products, you cannot add subscription products, if you want to add this product, the non-subscription products will be removed.');
                  let textSwal = 'Subscribe to save 15% & get Free Shipping?';
                  if($('body').hasClass('template-gamification-b') == true) {
                    if (cart.attributes != undefined) {
                      if (cart.attributes["Discount code"] && cart.attributes["Discount code"] != 'False' ) {
                        if (cart.attributes["Discount code"].indexOf('10XTH7YZNWPX') > -1) {
                          textSwal = textSwal.replace('15%', '20%');
                        }
                      }
                    }
                  }
                  Swal.fire({
                    title: 'You can save today',
                    text: textSwal,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonClass: 'btn',
                    cancelButtonText: 'No',
                    cancelButtonClass: 'btn',
                    customClass: {
                      container: 'swalBYOB swalBYOBPopups'
                    }
                  }).then((result) => {
                    if (result.isConfirmed) {
                      $('.cart__checkout').removeAttr('disabled').removeClass('disabled');
                      $('#ajaxcart__form-subs').trigger('click');
                      e.preventDefault();
                      return false;
                    } else {
                      goToCheckout(cartSubscription,isResult.cart);
                    }
                  });
                } else {
                  goToCheckout(cartSubscription,isResult.cart);
                }
                */
              } else {
                $('.build-your-kit--is-loading').show();
                goToCheckout(cartSubscription,isResult.cart);
              }
            }
            
          }
        });
      } else {
        e.preventDefault();
        return false;
      }
    });
  };
    
  sizeCartDrawerFooter = function() {
    // Elements are reprinted regularly so selectors are not cached
    var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
    var $cartButton = $('.ajaxcart__button').removeAttr('style');
    var $cartInner = $('.ajaxcart__inner').removeAttr('style');
    var $cartDrawerInner = $('#CartContainer').removeAttr('style');
    if($cartFooter.length != 0 && $cartButton.length != 0 && $cartInner.length != 0) {
      var cartFooterHeight = $cartFooter.outerHeight();
      var cartButtonHeight = $cartButton.outerHeight();
      var cartDrawerTitleHeight = $('.ajaxcart__head').outerHeight();
      var cartDrawerInnerHeight = $cartDrawerInner.outerHeight();
      $cartDrawerInner.css('height', cartDrawerInnerHeight - cartDrawerTitleHeight);

      $cartInner.css('bottom', cartFooterHeight + cartButtonHeight);
      $cartFooter.css('bottom', cartButtonHeight);
    } else {
      $cartDrawerInner.css('height', 0);
    }
    
    // Select the node that will be observed for mutations
    const targetNode = document.getElementsByClassName('ajaxcart__button dcodeapp');
    if( targetNode.length > 0 ) {
      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {
        /*for(let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
          }
          else if (mutation.type === 'attributes') {
            console.log('The ' + mutation.attributeName + ' attribute was modified.');
          }
        }*/
        sizeCartDrawerFooter();

        // Later, you can stop observing
        observer.disconnect();
      };
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(targetNode[0], config);
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.off('click', '.ajaxcart__qty-adjust').on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        if (document.querySelector('body').classList.contains('product--dont-add') == false) { qty += 1; } else { return; }
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // remove from the ajaxcart
    $body.off('click', '.ajaxcart__remove').on('click', '.ajaxcart__remove', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line');

      var qty = 0;

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Update quantity based on input on change
    $body.off('change', '.ajaxcart__qty-num').on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, '')),
          dataQty = parseInt($el.data('qty'));

      var qty = validateQty(qty);
      //console.log('gamificationDR.maxProductsToAdd',gamificationDR.maxProductsToAdd,'Shopify.dRItemsToAddCount',Shopify.dRItemsToAddCount,'dataQty',dataQty);
      let missingMeal = gamificationDR.maxProductsToAdd - (Shopify.dRItemsToAddCount - dataQty);
      //console.log('missingMeal',missingMeal,'qty',qty,'missingMeal + qty',missingMeal + qty,'missingMeal + qty > gamificationDR.maxProductsToAdd',missingMeal + qty > gamificationDR.maxProductsToAdd);
      if (missingMeal + qty > gamificationDR.maxProductsToAdd) {
        qty = missingMeal;
      }
      //console.log('qty',qty,'missingMeal',missingMeal);
      if (document.querySelector('body').classList.contains('product--dont-add') == true && qty > dataQty) {
        $el.val(dataQty);
        return;
      }

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.off('submit', 'form.ajaxcart').on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.off('focus', '.ajaxcart__qty-adjust').on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      $body.addClass('drawer--is-loading');

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.off('change', 'textarea[name="note"]').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });

    /*
    // Check subscribe
    $body.off('change', '.ajaxcart__form-subs').on('change', '.ajaxcart__form-subs', function() {
      if (isUpdating) {
        return;
      }
      console.log('change',$(this).is(':checked'));
      if ($(this).is(':checked') == false) {
        //if($('body').hasClass('template-gamification-b') == false) {
        //  ShopifyAPI.getCart(changeProductsToOnTime);
        //} else {
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToOneTime,true);
        //}
      } else {
        //if($('body').hasClass('template-gamification-b') == false) {
        //  ShopifyAPI.getCart(changeProductsToSubs);
        } else {
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToSubs,true);
        //}
      }
    });

    $body.off('change', '.ajaxcart__form-subs_select__frequency').on('change', '.ajaxcart__form-subs_select__frequency', function() {
      if (isUpdating) {
        return;
      }
      if ($('#ajaxcart__form-subs').val() == false) {
        //if($('body').hasClass('template-gamification-b') == false) {
        //  ShopifyAPI.getCart(changeProductsToOnTime);
        //} else {
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToOneTime);
        //}
      } else {
        //if($('body').hasClass('template-gamification-b') == false) {
        //  ShopifyAPI.getCart(changeProductsToSubs);
        //} else {
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToSubs);
        //}
      }
    });

    function changeProductsToSubs(cart) {
      
      // Show empty cart
      if (cart.item_count === 0) {
        $(settings.emptySelector).show();
        $(settings.triggerSelector).removeClass('js-cart-full');
        cartCallback(cart);
        return;
      }
      
      isUpdating = true;
      $body.addClass('drawer--is-loading');
      
      var itemsToAdd = [];
      var items = new Object();
      var quantityItems = 0;
      
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      if (Object.keys(productsSubscritionJson).length == 0) {
        return;
      }
      
      // Add each item to our handlebars.js data
      $.each(cart.items, function(index, cartItem) {
        var productSubscription = false,
            productSubscriptionId = '',
            productShippingIntervalFrequency = '',
            productShippingIntervalUnitType = '',
            productFreeGift = false;

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
            if (key === 'subscription_id') {
              productSubscriptionId = value;
            }
            if (key === 'shipping_interval_frequency') {
              productShippingIntervalFrequency = value;
            }
            if (key === 'shipping_interval_unit_type') {
              productShippingIntervalUnitType = value;
            }
            if (key === 'Free' && value === 'Gift') {
              productFreeGift = true;
            }
          });
        }
        
        if (productSubscription == false) {
          if (productsSubscritionJson[cartItem.product_id] != undefined) {
            if (productsSubscritionJson[cartItem.product_id]['subscriptionProductId'] != undefined) {
              if (productsSubscritionJson[cartItem.product_id]['subscriptionProductId'] != false) {
                var id = '';
                var quantity = 0;
                var subscription_id = $(this).attr('data-subscription-id');
                var properties = {};
                id = productsSubscritionJson[cartItem.product_id]['subscriptionProductId'];
                quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
                properties = {};
                if (cartItem['properties'] != null) {
                  properties = cartItem['properties'];
                }
                properties["AB Gamification"] = 'A';
                properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
                properties["shipping_interval_unit_type"] = 'Weeks';
                properties["subscription_id"] = productsSubscritionJson[cartItem.product_id]['subscriptionId'];
                items[id] = {
                  id: id, 
                  quantity: quantity, 
                  properties: properties
                };
                quantityItems += quantity;
              }
            }
          }
        } else {
          var id = '';
          var quantity = 0;
          var properties = {};
          id = cartItem.id;
          quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
          properties = {};
          if (cartItem['properties'] != null) {
            properties = cartItem['properties'];
          }
          properties["AB Gamification"] = 'A';
          properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
          properties["shipping_interval_unit_type"] = 'Weeks';
          properties["subscription_id"] = productSubscriptionId;
          items[id] = {
            id: id, 
            quantity: quantity, 
            properties: properties
          };
        }
      });
      
      //console.log(items);
      
      itemsToAdd.push(
        {
          items: items
        }
      );
      //console.log(itemsToAdd);
      
      var item = itemsToAdd.pop();
      //console.log(item);
      
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        async: false,
        dataType: "json",
        success: function(t) {
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            type: 'post',
            data: item,
            success: function(t) {
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'attributes[Product Type]=Subscription',
                dataType: 'json',
                success: function(cart) {
                  isUpdating = false;
                  cartUpdateCallback(cart);
                }
              });
            },
            error: itemErrorCallback
          });
        }
      });
    }
    
    function changeProductsToOnTime(cart) {
      
      // Show empty cart
      if (cart.item_count === 0) {
        $(settings.emptySelector).show();
        $(settings.triggerSelector).removeClass('js-cart-full');
        cartCallback(cart);
        return;
      }
      
      isUpdating = true;
      $body.addClass('drawer--is-loading');
      
      var itemsToAdd = [];
      var items = new Object();
      var quantityItems = 0;
      
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      if (Object.keys(productsSubscritionJson).length == 0) {
        return;
      }
      
      // Add each item to our handlebars.js data
      $.each(cart.items, function(index, cartItem) {
        var productSubscription = false,
            productSubscriptionId = '',
            productShippingIntervalFrequency = '',
            productShippingIntervalUnitType = '',
            productFreeGift = false;

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
            if (key === 'subscription_id') {
              productSubscriptionId = value;
            }
            if (key === 'shipping_interval_frequency') {
              productShippingIntervalFrequency = value;
            }
            if (key === 'shipping_interval_unit_type') {
              productShippingIntervalUnitType = value;
            }
            if (key === 'Free' && value === 'Gift') {
              productFreeGift = true;
            }
          });
        }
        
        
        if (productSubscription == false) {
          var id = '';
          var quantity = 0;
          id = cartItem.id;
          quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
          if (productFreeGift == false) {
            items[id] = {
              id: id, 
              quantity: quantity
            };
          } else {
            var properties = {};
            if (cartItem['properties'] != null) {
              properties["Free"] = 'Gift';
            }
            properties["AB Gamification"] = 'A';
            items[id] = {
              id: id, 
              quantity: quantity, 
              properties: properties
            };
          }
        } else {
          var id = '';
          var quantity = 0;
          for (var productSubscritionJson in productsSubscritionJson) {
            // obj.hasOwnProperty() is used to filter out properties from the object's prototype chain
            if (productsSubscritionJson.hasOwnProperty(productSubscritionJson)) {
              //console.log(productsSubscritionJson[productSubscritionJson]['subscriptionProductId'],cartItem.variant_id);
              if (productsSubscritionJson[productSubscritionJson]['subscriptionProductId'] == cartItem.variant_id) {
                id = productsSubscritionJson[productSubscritionJson]['variantId'];
                break;
              }
            }
          }
          if(id != '') {
            quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
            var properties = {};
            properties["AB Gamification"] = 'A';
            items[id] = {
              id: id, 
              quantity: quantity, 
              properties: properties
            };
          }
        }
      });
      
      //console.log(items);
      
      itemsToAdd.push(
        {
          items: items
        }
      );
      //console.log(itemsToAdd);
      
      var item = itemsToAdd.pop();
      //console.log(item);
      
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        async: false,
        dataType: "json",
        success: function(t) {
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            type: 'post',
            data: item,
            success: function(t) {
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'attributes[Product Type]=One Time',
                dataType: 'json',
                success: function(cart) {
                  isUpdating = false;
                  cartUpdateCallback(cart);
                }
              });
            },
            error: itemErrorCallback
          });
        }
      });
    }*/
    
    if (typeof searchSuggestion === "function") {
      $body.off('click', '.ajaxcart__addSuggestion').on('click', '.ajaxcart__addSuggestion', function() {
        if (isUpdating) {
          return;
        }

        isUpdating = true;
        $body.addClass('drawer--is-loading');

        //var data = '';
        var itemsToAdd = [];
        var items = new Object();
        if ($('.ajaxcart__form-subs').is(':checked') == false) {
          //data = "quantity=1&id=" + $(this).data('id');
          items[$(this).data('id')] = {
            id: $(this).data('id'), 
            quantity: 1
          };
        } else {
          var properties = {};
          properties = {};
          properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
          properties["shipping_interval_unit_type"] = 'Weeks';
          properties["subscription_id"] = $(this).data('subscription-id');
          items[$(this).data('subscription-product-id')] = {
            id: $(this).data('subscription-product-id'), 
            quantity: 1, 
            properties: properties
          };
        }
        
        itemsToAdd.push(
          {
            items: items
          }
        );

        var item = itemsToAdd.pop();
        
        $.ajax({
          url: '/cart/add',
          dataType: 'json',
          type: 'post',
          data: item,
          success: function(product) {
            isUpdating = false;
            //itemAddedCallback(product);
            ShopifyAPI.getCart(adjustCartCallback);
          },
          error: itemErrorCallback
        });
      });
    }
  };

  adjustCartCallback = function (cart) {
    let doneFreeGiftProduct = false,
        doneRulesDiscount = false;
    /*if($('body').hasClass('template-gamification-a') == true) {
      if(typeof freeGiftProduct == 'function' && doneFreeGiftProduct == false) {
        var result = freeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        console.log(result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      }
    } else if($('body').hasClass('template-gamification-b') == true) {*/
      if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct == false) {
        var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        console.log(result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      } else {
        if(typeof dRRulesDiscount == 'function') {
          var cartSubscription = false;
          if (cart['attributes']['Product Type'] == 'Subscription') {
            var cartSubscription = true;
          }
          var productPouches = 0;
          var total_price = 0;
          var totalPouches = 0;
          $.each(cart.items, function(index, cartItem) {
            var price = cartItem.price * cartItem.quantity;
            var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
            if (Object.keys(productsSubscritionJson).length > 0) {
              if(cartSubscription == true) {
                //console.log(price);
                for (x in productsSubscritionJson) {
                  //console.log(productsSubscritionJson[x]);
                  if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                    //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                    if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                      productPouches = productsSubscritionJson[x]['pouches'];
                      price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                      break;
                    }
                  }
                }
                //console.log(price);
              } else {
                if (productsSubscritionJson[cartItem.product_id] != undefined) {
                  productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
                }
              }
            }
            total_price += price;
            totalPouches += productPouches*cartItem.quantity;
          });
          dRRulesDiscount(totalPouches,cartSubscription);
          doneRulesDiscount = true;
        }
      }
    //}
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart, doneFreeGiftProduct, doneRulesDiscount);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]:not(.rc_variant_quantity)');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            sourceSingles = $("#JsQtySingles").html(),
            sourcePacks = $("#JsQtyPacks").html(),
            template = Handlebars.compile(source),
            templateSingles = Handlebars.compile(sourceSingles),
            templatePacks = Handlebars.compile(sourcePacks),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              pdp: $el.closest('.product-type__singles_pdp').length > 0 ? true : false
            };

        // Append new quantity selector then remove original
        if ($el.closest('.product-type__singles').length > 0) {
          $el.after(templateSingles(data)).remove();
        } else if ($el.closest('.product-type__pack').length > 0) {
          $el.after(templatePacks(data)).remove();
        } else {
          $el.after(template(data)).remove();
        }
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').off('click').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num:not(.js-qty__num-div)'),
            $qtySelectorTextBox = $el.siblings('.text-box').find('.js-qty__num:not(.js-qty__num-div)'),
            $qtySelectorSpan = $el.siblings('.js-qty__num-div'),
            qty = parseInt($qtySelector.length > 0 ? $qtySelector.val().replace(/\D/g, '') : $qtySelectorTextBox.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
        
        if ($el.closest('.js-product-form, .addtocart-form').length > 0) {
          if (qty > 18) qty = 18;
        }

        // Update the input's number
        if ($qtySelector.length > 0) {
          $qtySelector.val(qty);
        } else {
          $qtySelectorTextBox.val(qty);
        }
        
        if ($qtySelectorSpan.length > 0) {
          $qtySelectorSpan.find('span').removeClass('active');
          $qtySelectorSpan.find('[data-value=' + qty + ']').addClass('active');
        }
      });
      
      // Update quantity based on input on change
      $('.js-qty__num:not(.js-qty__num-div)').off('change').on('change', function() {

        var $el = $(this),
            qty = parseInt($el.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        if ($el.closest('.js-product-form, .addtocart-form').length > 0) {
          if (qty > 18) qty = 18;
        }
        
        $el.val(qty);
      });
      
      // Update quantity based on input on change
      $('.js-qty__num-div:not(.active)').off('click').on('click', function() {

        var $el = $(this),
            $qtySelector = $el.siblings('.js-qty__num:not(.js-qty__num-div)');

        if ($el.hasClass('open') == false) {
          $el.toggleClass('active');

          if ($el.hasClass('active') && $el.closest('.product-top').length > 0) {
            var $parent = $el.closest('.product-top');
            $parent.children('.js-qty__num-div_copy').remove();
            var $qtySelectorDivCopy = $el.clone().addClass('js-qty__num-div_copy').addClass('data-' + $qtySelector.val());
            $parent.after( $qtySelectorDivCopy );
            
            $('.js-qty__num-div_copy.active span').off('click').on('click', function() {

              var $el = $(this),
                  $qtySelectorDivCopy = $el.closest('.js-qty__num-div_copy'),
                  $parent = $el.closest('.product--natural'),
                  $qtySelector = $parent.find('.js-qty .js-qty__num:not(.js-qty__num-div)'),
                  $qtySelectorDiv = $parent.find('.js-qty .js-qty__num-div');

              var qty = $el.attr('data-value');

              $qtySelector.val(qty);

              $qtySelectorDiv.removeClass('active open').find('span').removeClass('active');
              $qtySelectorDiv.find('[data-value=' + qty + ']').addClass('active');

              $qtySelectorDivCopy.remove();

              //console.log(qty);
            });
          } else if ($el.hasClass('active')) {
            $el.addClass('data-' + $qtySelector.val());
            $('.js-qty__num-div.active span').off('click').on('click', function() {

              var $el = $(this),
                  $qtySelectorDiv = $el.closest('.js-qty__num-div'),
                  $qtySelector = $qtySelectorDiv.siblings('.js-qty__num:not(.js-qty__num-div)');

              var qty = $el.attr('data-value');

              $qtySelector.val(qty);

              $qtySelectorDiv.removeClass('active').removeClass (function (index, css) {
                return (css.match (/(^|\s)data-\S+/g) || []).join(' ');
              });
              $qtySelectorDiv.find('span').removeClass('active');
              $qtySelectorDiv.find('[data-value=' + qty + ']').addClass('active');


              //console.log(qty);
              //console.log($qtySelectorDiv.find('[data-value=' + qty + ']'));
              
              $('.js-qty__num-div.active span').off('click');
            });
          }
          
          $el.addClass('open');
        } else {
          $el.removeClass('open');
        }
      });
            
      $('body').off('click.onBodyClick').on('click.onBodyClick', function(event) {
        var $target = $(event.target),
            $targetSelector = $('.js-qty__num-div_copy.active');
        //console.log($targetSelector);
        //console.log($target);
        //console.log($target.parents('.js-qty__num-div.active').length);
        if (
          $target !== $targetSelector &&
          !$target.parents('.js-qty__num-div.active').length
        ) {
          $('.js-qty__num-div.active').removeClass('active open');
          $('.js-qty__num-div_copy').remove();
        }
        
        $('.js-qty__num-div.active').each(function() {
          //console.log($(this));
          //console.log($target.parents('.js-qty__num-div.active'));
          if (!$(this).is($target.parents('.js-qty__num-div.active'))) {
            $(this).removeClass('active open');
            //console.log('entro1');
          }
        });
        $('.js-qty__num-div_copy').each(function() {
          //let $this = $(this);
          //let $targetDivCopy = $target.parents('.product--natural').find('.js-qty__num-div_copy');
          //console.log($this);
          //console.log($targetDivCopy);
          if (!$(this).is($target.parents('.product--natural').find('.js-qty__num-div_copy'))) {
            $(this).remove();
            //console.log('entro2');
          }
        });
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    loadWithOutGetCart: loadCartWithOutGetCart,
    loadWithOut: loadWithOutCart
  };

  return module;

}(ajaxCart || {}, jQuery));
